

export const translations = {
    en: {
        // Login
        welcome: "Welcome Farmer", enterMobile: "Enter your mobile number to proceed",
        mobileLabel: "Mobile Number", mobilePlaceholder: "Enter your mobile number",
        termsText: "I accept the", termsLink: "Terms & Conditions",
        submit: "Submit", sendingOtp: "Sending OTP...", invalidMobile: "Invalid Mobile Number",
        otpSentTo: "Code sent to +91", loginWithOtp: "Login with OTP",
        otpSentMessage: "Enter OTP sent to +91",
        otpError: "Please enter all 4 digits of the OTP",
        invalidOtp: "Invalid OTP. Please try again.",
        login: "Login", verifying: "Verifying...",
        resendOtp: "Resend OTP", otpResent: "OTP Resent",
        footer: "Sustainable Farming Solutions",
        // ProfileSetup
        profile_heading: "Complete Your Profile",
        profile_subheading: "Complete your profile to continue",
        profile_nameLabel: "Full Name", profile_namePlaceholder: "Enter your full name",
        profile_pincodeLabel: "Pin Code", profile_pincodePlaceholder: "Enter 6-digit pincode",
        profile_stateLabel: "State", profile_districtLabel: "District",
        profile_villageLabel: "Village", profile_acreageLabel: "Total Acreage",
        profile_acreagePlaceholder: "e.g. 12",
        profile_autoFill: "Auto-filled from pincode",
        profile_infoNote: "Please fill all details carefully. These cannot be changed later.",
        profile_saveBtn: "Save & Continue",
        profile_saved: "Profile saved successfully!",
        profile_saveError: "Something went wrong. Please try again.",
        profile_invalidPincode: "Invalid pincode",
        profile_pincodeError: "Could not fetch pincode details",
        profile_errName: "Please enter your name",
        profile_errPincode: "Enter a valid 6-digit pincode",
        profile_errLocation: "Please enter a valid pincode to auto-fill location",
        profile_errAcreage: "Please enter total acreage",
        profile_errAge: "Please enter age",
        profile_ageLabel: "Age",

        profile_myProfile: 'My Profile',
        profile_locationDetails: 'Location Details',
        profile_farmDetails: ' Details',
        profile_state: 'State',
        profile_district: 'District',
        profile_village: 'Village',
        profile_pincode: 'Pincode',
        profile_totalAcreage: 'Total Acreage',
        profile_acres: 'Acres',
        profile_noticeText: 'Profile details are verified and cannot be changed. Please contact support for any corrections.',
        profile_backToDashboard: 'Back to Dashboard',
        profile_logout: 'Log out',
        profile_logoutTitle: 'Log out?',
        profile_logoutMsg: 'You\'ll need to sign in again to access your account.',
        profile_cancel: 'Cancel',
        profile_logoutConfirm: 'Yes, log out',

        notFound_message: 'Page not found',
        notFound_goHome: 'Go Home',

        slogan_pageTitle: 'Slogan Contest',
        slogan_contestLabel: 'Grand Prize Contest',
        slogan_enterTitle: 'Enter Your Slogan',
        slogan_enterSubtitle: 'Submit your creative slogan to participate and win big!',
        slogan_inputLabel: 'Mujhe Agrosatva bottle mein mila/mili',
        slogan_placeholder: 'Write your slogan here...',
        slogan_submit: 'Submit Slogan',
        slogan_submitting: 'Submitting...',
        slogan_errEmpty: 'Please enter your slogan.',
        slogan_errFailed: 'Something went wrong. Please try again.',
        slogan_alreadyTitle: 'You\'re in the contest!',
        slogan_alreadyMsg: 'We have already received your entry for the Grand Prize contest. Results will be announced once the contest ends!',
        slogan_goHome: 'Go to Home',

        redeem_pageTitle: 'View History',
        redeem_balance: 'Balance',
        redeem_totalEarned: 'Total Earned',
        redeem_transferred: 'Transferred',
        redeem_transferFunds: 'Transfer Funds',
        redeem_upiId: 'UPI ID',
        redeem_bankAccount: 'Bank Account',
        redeem_tabEarned: 'EARNED',
        redeem_tabTransferred: 'TRANSFERRED',
        redeem_noTransactions: 'No transactions',
        redeem_errNoBalance: 'No balance available to transfer',

        scan_pageTitle: 'Scan Code',
        scan_pointCamera: 'Point camera at QR code',
        scan_cameraUnavailable: 'Camera not available. Please use manual entry below.',
        scan_orEnterManually: 'Or Enter Manually',
        scan_placeholder: 'CB45SYR463F',
        scan_submitCode: 'Submit Code',
        scan_congrats: 'Congrats!',
        scan_youEarned: 'You have earned',
        scan_cashbackRewards: 'a cashback reward',
        scan_viewEarnings: 'Transfer Now',
        scan_scanAnother: 'Scan another code',
        scan_grandPrizeBtn: 'ENTER GRAND PRIZE CONTEST',
        scan_voucherVerified: 'Voucher Verified',
        scan_contestSubmitted: 'Contest Entry Submitted ✅',
        scan_contestSubmittedMsg: 'Congrats! You are eligible for the Grand Prize contest. Results will be declared after the contest ends.',
        scan_contestNotSubmitted: 'Contest Entry Not Submitted',
        scan_contestNotSubmittedMsg: 'Submit your slogan to participate!',
        scan_submitSlogan: 'Submit Slogan',
        scan_verificationFailed: 'Verification Failed',
        scan_tryAgain: 'Try Again',
        scan_errInvalid: 'Invalid voucher code.',
        scan_errUsed: 'This voucher has already been used.',
        scan_errAssigned: 'This voucher is already assigned.',
        scan_errExpired: 'This voucher has expired.',
        scan_errSuccess: 'Voucher verified successfully!',

        bank_pageTitle: 'Bank Details',
        bank_addTitle: 'Add Bank Account',
        bank_ifscLabel: 'IFSC Code',
        bank_ifscPlaceholder: 'e.g. SBIN0001234',
        bank_accountLabel: 'Account Number',
        bank_accountPlaceholder: 'Enter account number',
        bank_confirmLabel: 'Re-enter Account',
        bank_confirmPlaceholder: 'Confirm account number',
        bank_addBtn: 'Add Account',
        bank_transferBtn: 'Transfer Amount',
        bank_addAnotherBtn: 'Add another account',
        bank_holderName: 'Account Holder',
        bank_accountNumber: 'Account Number',
        bank_ifscCode: 'IFSC Code',
        bank_bankName: 'Bank Name',
        bank_default: 'Default',
        bank_setDefault: 'Set as Default',
        bank_delete: 'Delete',
        bank_errFillAll: 'Please fill all fields',
        bank_errMismatch: 'Account numbers do not match',
        bank_errInvalidIfsc: 'Invalid IFSC code',
        bank_errVerifyFailed: 'Account verification failed',
        bank_errVerifyError: 'Verification error. Please try again.',
        bank_errIfscFetch: 'Error fetching bank details',
        bank_successAdded: 'Bank account added successfully',
        bank_successDeleted: 'Account deleted',
        bank_successDefault: 'Default account updated',

        upi_pageTitle: 'UPI Details',
        upi_mobileLabel: 'Mobile Number (UPI)',
        upi_mobilePlaceholder: 'Enter mobile number',
        upi_verifiedLabel: 'Verified Successfully',
        upi_name: 'Name',
        upi_upiId: 'UPI ID',
        upi_mobile: 'Mobile',
        upi_btnWait: 'Please wait...',
        upi_btnProceed: 'Proceed',
        upi_btnVerify: 'Verify Mobile Number',
        upi_errInvalidMobile: 'Enter a valid 10-digit mobile number',
        upi_successVerified: 'Mobile number verified successfully!',
        upi_errFailed: 'Mobile number verification failed',
        upi_errGeneric: 'Something went wrong. Please try again.',

        confirm_pageTitle: 'Payment Details',
        confirm_transferAmount: 'Transfer Amount',
        confirm_noBalance: 'No balance available to transfer',
        confirm_vouchersLabel: 'Vouchers to Redeem',
        confirm_paymentMethod: 'Payment Method',
        confirm_upi: 'UPI',
        confirm_bankTransfer: 'Bank Transfer',
        confirm_bank: 'Bank',
        confirm_account: 'Account',
        confirm_ifsc: 'IFSC',
        confirm_name: 'Name',
        confirm_btnNoBalance: 'No Balance Available',
        confirm_btnConfirm: 'Confirm & Transfer',
        confirm_errGeneric: 'Something went wrong. Please try again.',
        confirm_popupLabel: 'Success',
        confirm_popupTitle: 'Your request has been submitted successfully. The payout will be processed within 2 hours.',
        confirm_popupMsg: 'Any requests submitted after 6 PM will be processed on the next working day.',
        confirm_popupTotal: 'Total redeemed',
        confirm_warningTitle: '⚠ Transfer Pending',
        confirm_warningMsg: 'Due to an internal issue, the amount could not be transferred to your account instantly. Our team will process it shortly. Please contact support if needed.',
        confirm_done: 'Done',

        home_welcome: 'WELCOME',
        home_totalEarned: 'TOTAL EARNED',
        home_transferred: 'TRANSFERRED',
        home_balance: 'BALANCE',
        home_viewEarnings: 'VIEW HISTORY',
        home_grandPrizeBtn: 'ENTER GRAND PRIZE CONTEST',
        home_cash: 'REDEEM CASH',
        home_giftcard: 'REDEEM GIFTCARD',
        home_promoTitle: 'Promo Code',
        home_promoSubtitle: 'Scan QR or enter code from your Agrosatva pack',
        home_scanBtn: 'Scan / Enter Code',
        home_enterCodeTitle: 'Enter Voucher Code',
        home_enterCodePlaceholder: 'Enter code',
        home_submit: 'Submit',
        home_alreadyAssignedTitle: 'Voucher is already assigned!',
        home_tryAnother: 'Try another coupon',
        home_congrats: 'Congrats!',
        home_youEarned: 'You have earned',
        home_cashbackRewards: 'a cashback rewards',
        home_viewEarningsBtn: 'Claim Earnings',
        home_scanAnother: 'Scan another code',
        home_inContestTitle: 'You\'re in the contest',
        home_congratsTitle: 'Congratulations',
        home_contestReceivedMsg: 'We have already received your entry for the Grand Prize contest. Results will be announced once the contest ends!',
        home_scanMoreBtn: 'Scan another coupon to WIN more',
        home_goHome: 'Go To Home',
        home_eligibleMsg: 'You are eligible for the Grand Prize contest. Please click on below link to participate in the contest',
        home_participate: 'Participate',
        home_verificationFailed: 'Verification Failed',
        home_tryAgain: 'Try Again',
        home_errInvalid: 'Invalid voucher code.',
        home_errUsed: 'This voucher has already been used.',
        home_errMaxLimit: 'You have reached the maximum limit of 10 vouchers.',
        home_errAssignedMine: 'This voucher is already in your account.',
        home_errAssignedOther: 'This voucher is already assigned to another user.',
        home_errExpired: 'This voucher has expired.',
        home_errSuccess: 'Voucher verified successfully!',
        slogan_popupLabel: 'Submitted!',
        slogan_popupTitle: 'Thank You!',
        slogan_popupMsg: 'Your slogan has been successfully submitted, and you are now part of the Grand Prize contest. Stay tuned — results will be announced once the contest ends!',
        appTitle: 'Dhanuka Bank',
        appDescription: 'Sustainable Farming Solutions',

        game_betterLuck: "Try Next Time",
        game_spinAndWin: "🎡 Spin & Win",
        game_spin: "Spin",
        game_congratulations: "🎉 Congratulations!",
        game_youWon: "You won",
        game_dontWorry: "Don’t worry, try again!",
        game_dashboard: "Go Back to Dashboard",
        game_playAgain: "Play Again",
        game_luckyGame: " LUCKY GAME",
        game_Desc: " Spin the wheel and win exciting rewards instantly.",
        game_points: "Points"
    },
    hi: {
        welcome: "स्वागत है किसान", enterMobile: "आगे बढ़ने के लिए मोबाइल नंबर दर्ज करें",
        mobileLabel: "मोबाइल नंबर", mobilePlaceholder: "10 अंकों का मोबाइल नंबर दर्ज करें",
        termsText: "मैं स्वीकार करता/करती हूँ", termsLink: "नियम और शर्तें",
        submit: "जमा करें", sendingOtp: "OTP भेजा जा रहा है...", invalidMobile: "अमान्य मोबाइल नंबर",
        otpSentTo: "कोड भेजा गया +91", loginWithOtp: "OTP से लॉगिन करें",
        otpSentMessage: "OTP भेजा गया +91",
        otpError: "कृपया OTP के सभी 4 अंक दर्ज करें",
        invalidOtp: "गलत OTP। कृपया पुनः प्रयास करें।",
        login: "लॉगिन", verifying: "सत्यापित हो रहा है...",
        resendOtp: "OTP पुनः भेजें", otpResent: "OTP पुनः भेजा गया",
        footer: "टिकाऊ खेती समाधान",
        profile_heading: "प्रोफ़ाइल पूरी करें",
        profile_subheading: "जारी रखने के लिए अपनी प्रोफ़ाइल पूरी करें",
        profile_nameLabel: "पूरा नाम", profile_namePlaceholder: "अपना पूरा नाम दर्ज करें",
        profile_pincodeLabel: "पिनकोड", profile_pincodePlaceholder: "6 अंकों का पिनकोड दर्ज करें",
        profile_stateLabel: "राज्य", profile_districtLabel: "जिला",
        profile_villageLabel: "गाँव", profile_acreageLabel: "कुल एकड़",
        profile_acreagePlaceholder: "जैसे 12",
        profile_autoFill: "पिनकोड से स्वतः भरा जाएगा",
        profile_infoNote: "कृपया सभी जानकारी ध्यान से भरें। इसे बाद में बदला नहीं जा सकता।",
        profile_saveBtn: "सहेजें और जारी रखें",
        profile_saved: "प्रोफ़ाइल सफलतापूर्वक सहेजी गई!",
        profile_saveError: "कुछ गलत हो गया। कृपया पुनः प्रयास करें।",
        profile_invalidPincode: "अमान्य पिनकोड",
        profile_pincodeError: "पिनकोड विवरण प्राप्त नहीं हो सका",
        profile_errName: "कृपया अपना नाम दर्ज करें",
        profile_errPincode: "एक वैध 6 अंकों का पिनकोड दर्ज करें",
        profile_errLocation: "स्थान भरने के लिए एक वैध पिनकोड दर्ज करें",
        profile_errAcreage: "कृपया कुल एकड़ दर्ज करें",
        profile_errAge: "कृपया आयु दर्ज करें",
        profile_ageLabel: "आयु",

        profile_myProfile: 'मेरी प्रोफ़ाइल',
        profile_locationDetails: 'स्थान विवरण',
        profile_farmDetails: 'खेत विवरण',
        profile_state: 'राज्य',
        profile_district: 'जिला',
        profile_village: 'गाँव',
        profile_pincode: 'पिनकोड',
        profile_totalAcreage: 'कुल एकड़',
        profile_acres: 'एकड़',
        profile_noticeText: 'प्रोफ़ाइल विवरण सत्यापित हैं और बदले नहीं जा सकते। किसी भी सुधार के लिए सहायता से संपर्क करें।',
        profile_backToDashboard: 'डैशबोर्ड पर वापस जाएं',
        profile_logout: 'लॉग आउट',
        profile_logoutTitle: 'लॉग आउट करें?',
        profile_logoutMsg: 'आपको अपने खाते तक पहुंचने के लिए फिर से साइन इन करना होगा।',
        profile_cancel: 'रद्द करें',
        profile_logoutConfirm: 'हाँ, लॉग आउट करें',

        notFound_message: 'पृष्ठ नहीं मिला',
        notFound_goHome: 'होम पर जाएं',

        slogan_pageTitle: 'स्लोगन प्रतियोगिता',
        slogan_contestLabel: 'ग्रैंड प्राइज़ प्रतियोगिता',
        slogan_enterTitle: 'अपना स्लोगन दर्ज करें',
        slogan_enterSubtitle: 'भाग लेने और बड़ा जीतने के लिए अपना रचनात्मक स्लोगन सबमिट करें!',
        slogan_inputLabel: 'मुझे Agrosatva की बोतल में मिला / मिली।',
        slogan_placeholder: 'यहाँ अपना स्लोगन लिखें...',
        slogan_submit: 'स्लोगन सबमिट करें',
        slogan_submitting: 'सबमिट हो रहा है...',
        slogan_errEmpty: 'कृपया अपना स्लोगन दर्ज करें।',
        slogan_errFailed: 'कुछ गलत हो गया। कृपया पुनः प्रयास करें।',
        slogan_alreadyTitle: 'आप प्रतियोगिता में हैं!',
        slogan_alreadyMsg: 'हमें ग्रैंड प्राइज़ प्रतियोगिता के लिए आपकी प्रविष्टि मिल चुकी है। प्रतियोगिता समाप्त होने के बाद परिणाम घोषित किए जाएंगे!',
        slogan_goHome: 'होम पर जाएं',

        redeem_pageTitle: 'कमाई देखें',
        redeem_balance: 'बैलेंस',
        redeem_totalEarned: 'कुल कमाई',
        redeem_transferred: 'ट्रांसफर किया',
        redeem_transferFunds: 'फंड ट्रांसफर करें',
        redeem_upiId: 'UPI ID',
        redeem_bankAccount: 'बैंक खाता',
        redeem_tabEarned: 'अर्जित',
        redeem_tabTransferred: 'ट्रांसफर',
        redeem_noTransactions: 'कोई लेनदेन नहीं',
        redeem_errNoBalance: 'ट्रांसफर के लिए कोई बैलेंस उपलब्ध नहीं है',

        scan_pageTitle: 'कोड स्कैन करें',
        scan_pointCamera: 'QR कोड पर कैमरा निर्देशित करें',
        scan_cameraUnavailable: 'कैमरा उपलब्ध नहीं है। कृपया नीचे मैन्युअल एंट्री का उपयोग करें।',
        scan_orEnterManually: 'या मैन्युअल दर्ज करें',
        scan_placeholder: 'CB45SYR463F',
        scan_submitCode: 'कोड सबमिट करें',
        scan_congrats: 'बधाई हो!',
        scan_youEarned: 'आपने अर्जित किया है',
        scan_cashbackRewards: 'एक कैशबैक रिवॉर्ड',
        scan_viewEarnings: 'अभी ट्रांसफर करें',
        scan_scanAnother: 'दूसरा कोड स्कैन करें',
        scan_grandPrizeBtn: 'ग्रैंड प्राइज़ प्रतियोगिता में प्रवेश करें',
        scan_voucherVerified: 'वाउचर सत्यापित',
        scan_contestSubmitted: 'प्रतियोगिता प्रविष्टि सबमिट ✅',
        scan_contestSubmittedMsg: 'बधाई! आप ग्रैंड प्राइज़ प्रतियोगिता के पात्र हैं। प्रतियोगिता समाप्त होने के बाद परिणाम घोषित किए जाएंगे।',
        scan_contestNotSubmitted: 'प्रतियोगिता प्रविष्टि सबमिट नहीं हुई',
        scan_contestNotSubmittedMsg: 'भाग लेने के लिए अपना स्लोगन सबमिट करें!',
        scan_submitSlogan: 'स्लोगन सबमिट करें',
        scan_verificationFailed: 'सत्यापन विफल',
        scan_tryAgain: 'पुनः प्रयास करें',
        scan_errInvalid: 'अमान्य वाउचर कोड।',
        scan_errUsed: 'यह वाउचर पहले ही उपयोग हो चुका है।',
        scan_errAssigned: 'यह वाउचर पहले ही असाइन हो चुका है।',
        scan_errExpired: 'यह वाउचर समाप्त हो गया है।',
        scan_errSuccess: 'वाउचर सफलतापूर्वक सत्यापित!',

        bank_pageTitle: 'बैंक विवरण',
        bank_addTitle: 'बैंक खाता जोड़ें',
        bank_ifscLabel: 'IFSC कोड',
        bank_ifscPlaceholder: 'जैसे SBIN0001234',
        bank_accountLabel: 'खाता संख्या',
        bank_accountPlaceholder: 'खाता संख्या दर्ज करें',
        bank_confirmLabel: 'खाता पुनः दर्ज करें',
        bank_confirmPlaceholder: 'खाता संख्या की पुष्टि करें',
        bank_addBtn: 'खाता जोड़ें',
        bank_transferBtn: 'राशि ट्रांसफर करें',
        bank_addAnotherBtn: 'दूसरा खाता जोड़ें',
        bank_holderName: 'खाताधारक',
        bank_accountNumber: 'खाता संख्या',
        bank_ifscCode: 'IFSC कोड',
        bank_bankName: 'बैंक का नाम',
        bank_default: 'डिफ़ॉल्ट',
        bank_setDefault: 'डिफ़ॉल्ट सेट करें',
        bank_delete: 'हटाएं',
        bank_errFillAll: 'कृपया सभी फ़ील्ड भरें',
        bank_errMismatch: 'खाता संख्याएं मेल नहीं खातीं',
        bank_errInvalidIfsc: 'अमान्य IFSC कोड',
        bank_errVerifyFailed: 'खाता सत्यापन विफल',
        bank_errVerifyError: 'सत्यापन त्रुटि। कृपया पुनः प्रयास करें।',
        bank_errIfscFetch: 'बैंक विवरण प्राप्त करने में त्रुटि',
        bank_successAdded: 'बैंक खाता सफलतापूर्वक जोड़ा गया',
        bank_successDeleted: 'खाता हटाया गया',
        bank_successDefault: 'डिफ़ॉल्ट खाता अपडेट किया गया',

        upi_pageTitle: 'UPI विवरण',
        upi_mobileLabel: 'मोबाइल नंबर (UPI)',
        upi_mobilePlaceholder: 'मोबाइल नंबर दर्ज करें',
        upi_verifiedLabel: 'सफलतापूर्वक सत्यापित',
        upi_name: 'नाम',
        upi_upiId: 'UPI ID',
        upi_mobile: 'मोबाइल',
        upi_btnWait: 'कृपया प्रतीक्षा करें...',
        upi_btnProceed: 'आगे बढ़ें',
        upi_btnVerify: 'मोबाइल नंबर सत्यापित करें',
        upi_errInvalidMobile: 'एक वैध 10 अंकों का मोबाइल नंबर दर्ज करें',
        upi_successVerified: 'मोबाइल नंबर सफलतापूर्वक सत्यापित!',
        upi_errFailed: 'मोबाइल नंबर सत्यापन विफल',
        upi_errGeneric: 'कुछ गलत हो गया। कृपया पुनः प्रयास करें।',

        confirm_pageTitle: 'भुगतान विवरण',
        confirm_transferAmount: 'ट्रांसफर राशि',
        confirm_noBalance: 'ट्रांसफर के लिए कोई बैलेंस उपलब्ध नहीं',
        confirm_vouchersLabel: 'रिडीम करने के वाउचर',
        confirm_paymentMethod: 'भुगतान विधि',
        confirm_upi: 'UPI',
        confirm_bankTransfer: 'बैंक ट्रांसफर',
        confirm_bank: 'बैंक',
        confirm_account: 'खाता',
        confirm_ifsc: 'IFSC',
        confirm_name: 'नाम',
        confirm_btnNoBalance: 'कोई बैलेंस उपलब्ध नहीं',
        confirm_btnConfirm: 'पुष्टि करें और ट्रांसफर करें',
        confirm_errGeneric: 'कुछ गलत हो गया। कृपया पुनः प्रयास करें।',
        confirm_popupLabel: 'सफल',
        confirm_popupTitle:
            "आपका अनुरोध सफलतापूर्वक सबमिट हो गया है। भुगतान 2 घंटे के भीतर प्रोसेस किया जाएगा।",
        confirm_popupMsg:
            "शाम 6 बजे के बाद किए गए अनुरोध अगले कार्य दिवस पर प्रोसेस किए जाएंगे।",
        confirm_popupTotal: 'कुल रिडीम',
        confirm_warningTitle: '⚠ ट्रांसफर लंबित',
        confirm_warningMsg: 'एक आंतरिक समस्या के कारण राशि तुरंत आपके खाते में स्थानांतरित नहीं हो सकी। हमारी टीम जल्द ही इसे प्रोसेस करेगी। यदि आवश्यक हो तो सहायता से संपर्क करें।',
        confirm_done: 'हो गया',

        home_welcome: 'स्वागत',
        home_totalEarned: 'कुल कमाई',
        home_transferred: 'ट्रांसफर',
        home_balance: 'बैलेंस',
        home_viewEarnings: 'कमाई देखें',
        home_grandPrizeBtn: 'ग्रैंड प्राइज़ प्रतियोगिता में जाएं',
        home_promoTitle: 'प्रोमो कोड',
        home_promoSubtitle: 'अपने Agrosatva पैक से QR स्कैन करें या कोड दर्ज करें',
        home_scanBtn: 'स्कैन / कोड दर्ज करें',
        home_enterCodeTitle: 'वाउचर कोड दर्ज करें',
        home_enterCodePlaceholder: 'कोड दर्ज करें',
        home_submit: 'सबमिट',
        home_alreadyAssignedTitle: 'वाउचर पहले से असाइन है!',
        home_tryAnother: 'दूसरा कूपन आज़माएं',
        home_congrats: 'बधाई हो!',
        home_youEarned: 'आपने अर्जित किया है',
        home_cashbackRewards: 'एक कैशबैक रिवॉर्ड',
        home_viewEarningsBtn: "कमाई प्राप्त करें",
        home_scanAnother: 'दूसरा कोड स्कैन करें',
        home_inContestTitle: 'आप प्रतियोगिता में हैं',
        home_congratsTitle: 'बधाई हो',
        home_contestReceivedMsg: 'हमें ग्रैंड प्राइज़ प्रतियोगिता के लिए आपकी प्रविष्टि मिल चुकी है। प्रतियोगिता समाप्त होने के बाद परिणाम घोषित किए जाएंगे!',
        home_scanMoreBtn: 'अधिक जीतने के लिए दूसरा कूपन स्कैन करें',
        home_goHome: 'होम पर जाएं',
        home_eligibleMsg: 'आप ग्रैंड प्राइज़ प्रतियोगिता के लिए पात्र हैं। कृपया प्रतियोगिता में भाग लेने के लिए नीचे दिए गए लिंक पर क्लिक करें',
        home_participate: 'भाग लें',
        home_verificationFailed: 'सत्यापन विफल',
        home_tryAgain: 'पुनः प्रयास करें',
        home_errInvalid: 'अमान्य वाउचर कोड।',
        home_errUsed: 'यह वाउचर पहले ही उपयोग हो चुका है।',
        home_errMaxLimit: 'आपने 10 वाउचर की अधिकतम सीमा पार कर ली है।',
        home_errAssignedMine: 'यह वाउचर पहले से आपके खाते में है।',
        home_errAssignedOther: 'यह वाउचर पहले से किसी और उपयोगकर्ता को असाइन है।',
        home_errExpired: 'यह वाउचर समाप्त हो गया है।',
        home_errSuccess: 'वाउचर सफलतापूर्वक सत्यापित!',
        slogan_popupLabel: 'सबमिट हो गया!',
        slogan_popupTitle: 'धन्यवाद!',
        slogan_popupMsg: 'आपका स्लोगन सफलतापूर्वक सबमिट हो गया है और आप ग्रैंड प्राइज़ प्रतियोगिता का हिस्सा बन गए हैं। परिणाम की प्रतीक्षा करें!',
        appTitle: 'जेनक्रेस्ट एग्रोसत्वा',
        appDescription: 'टिकाऊ खेती समाधान',

        game_betterLuck: "अगली बार कोशिश करें",
        game_spinAndWin: "🎡 स्पिन और जीतें",
        game_spin: "स्पिन",
        game_congratulations: "🎉 बधाई हो!",
        game_youWon: "आपने जीता",
        game_dontWorry: "चिंता मत करें, फिर से प्रयास करें!",
        game_dashboard: "डैशबोर्ड पर वापस जाएं",
        game_playAgain: "फिर से खेलें",
        game_luckyGame: "लकी गेम",
        game_Desc: "पहिया घुमाएं और तुरंत शानदार इनाम जीतें।",
        game_points: "पॉइंट्स"
    },
    pa: {
        welcome: "ਜੀ ਆਇਆਂ ਕਿਸਾਨ", enterMobile: "ਅੱਗੇ ਵਧਣ ਲਈ ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ",
        mobileLabel: "ਮੋਬਾਈਲ ਨੰਬਰ", mobilePlaceholder: "10 ਅੰਕਾਂ ਦਾ ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ",
        termsText: "ਮੈਂ ਸਵੀਕਾਰ ਕਰਦਾ/ਕਰਦੀ ਹਾਂ", termsLink: "ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ",
        submit: "ਜਮ੍ਹਾਂ ਕਰੋ", sendingOtp: "OTP ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ...", invalidMobile: "ਗਲਤ ਮੋਬਾਈਲ ਨੰਬਰ",
        otpSentTo: "ਕੋਡ ਭੇਜਿਆ ਗਿਆ +91", loginWithOtp: "OTP ਨਾਲ ਲੌਗਿਨ ਕਰੋ",
        otpSentMessage: "OTP ਭੇਜਿਆ ਗਿਆ +91",
        otpError: "ਕਿਰਪਾ ਕਰਕੇ OTP ਦੇ ਸਾਰੇ 4 ਅੰਕ ਦਰਜ ਕਰੋ",
        invalidOtp: "ਗਲਤ OTP। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
        login: "ਲੌਗਿਨ", verifying: "ਤਸਦੀਕ ਹੋ ਰਹੀ ਹੈ...",
        resendOtp: "OTP ਦੁਬਾਰਾ ਭੇਜੋ", otpResent: "OTP ਦੁਬਾਰਾ ਭੇਜਿਆ ਗਿਆ",
        footer: "ਟਿਕਾਊ ਖੇਤੀ ਹੱਲ",
        profile_heading: "ਪ੍ਰੋਫਾਈਲ ਪੂਰੀ ਕਰੋ",
        profile_subheading: "ਜਾਰੀ ਰੱਖਣ ਲਈ ਆਪਣੀ ਪ੍ਰੋਫਾਈਲ ਪੂਰੀ ਕਰੋ",
        profile_nameLabel: "ਪੂਰਾ ਨਾਮ", profile_namePlaceholder: "ਆਪਣਾ ਪੂਰਾ ਨਾਮ ਦਰਜ ਕਰੋ",
        profile_pincodeLabel: "ਪਿਨਕੋਡ", profile_pincodePlaceholder: "6 ਅੰਕਾਂ ਦਾ ਪਿਨਕੋਡ ਦਰਜ ਕਰੋ",
        profile_stateLabel: "ਰਾਜ", profile_districtLabel: "ਜ਼ਿਲ੍ਹਾ",
        profile_villageLabel: "ਪਿੰਡ", profile_acreageLabel: "ਕੁੱਲ ਏਕੜ",
        profile_acreagePlaceholder: "ਜਿਵੇਂ 12",
        profile_autoFill: "ਪਿਨਕੋਡ ਤੋਂ ਆਪਣੇ ਆਪ ਭਰਿਆ ਜਾਵੇਗਾ",
        profile_infoNote: "ਕਿਰਪਾ ਕਰਕੇ ਸਾਰੇ ਵੇਰਵੇ ਧਿਆਨ ਨਾਲ ਭਰੋ। ਇਹਨਾਂ ਨੂੰ ਬਾਅਦ ਵਿੱਚ ਬਦਲਿਆ ਨਹੀਂ ਜਾ ਸਕਦਾ।",
        profile_saveBtn: "ਸੇਵ ਕਰੋ ਅਤੇ ਜਾਰੀ ਰੱਖੋ",
        profile_saved: "ਪ੍ਰੋਫਾਈਲ ਸਫਲਤਾਪੂਰਵਕ ਸੇਵ ਕੀਤੀ ਗਈ!",
        profile_saveError: "ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
        profile_invalidPincode: "ਗਲਤ ਪਿਨਕੋਡ",
        profile_pincodeError: "ਪਿਨਕੋਡ ਵੇਰਵੇ ਪ੍ਰਾਪਤ ਨਹੀਂ ਹੋ ਸਕੇ",
        profile_errName: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਨਾਮ ਦਰਜ ਕਰੋ",
        profile_errPincode: "ਇੱਕ ਵੈਧ 6 ਅੰਕਾਂ ਦਾ ਪਿਨਕੋਡ ਦਰਜ ਕਰੋ",
        profile_errLocation: "ਸਥਾਨ ਭਰਨ ਲਈ ਇੱਕ ਵੈਧ ਪਿਨਕੋਡ ਦਰਜ ਕਰੋ",
        profile_errAcreage: "ਕਿਰਪਾ ਕਰਕੇ ਕੁੱਲ ਏਕੜ ਦਰਜ ਕਰੋ",
        profile_errAge: "ਕਿਰਪਾ ਕਰਕੇ ਉਮਰ ਦਰਜ ਕਰੋ",
        profile_ageLabel: "ਉਮਰ",

        profile_myProfile: 'ਮੇਰੀ ਪ੍ਰੋਫਾਈਲ',
        profile_locationDetails: 'ਸਥਾਨ ਵੇਰਵੇ',
        profile_farmDetails: 'ਖੇਤ ਵੇਰਵੇ',
        profile_state: 'ਰਾਜ',
        profile_district: 'ਜ਼ਿਲ੍ਹਾ',
        profile_village: 'ਪਿੰਡ',
        profile_pincode: 'ਪਿਨਕੋਡ',
        profile_totalAcreage: 'ਕੁੱਲ ਏਕੜ',
        profile_acres: 'ਏਕੜ',
        profile_noticeText: 'ਪ੍ਰੋਫਾਈਲ ਵੇਰਵੇ ਤਸਦੀਕ ਕੀਤੇ ਗਏ ਹਨ ਅਤੇ ਬਦਲੇ ਨਹੀਂ ਜਾ ਸਕਦੇ। ਕਿਸੇ ਵੀ ਸੁਧਾਰ ਲਈ ਸਹਾਇਤਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।',
        profile_backToDashboard: 'ਡੈਸ਼ਬੋਰਡ ਤੇ ਵਾਪਸ ਜਾਓ',
        profile_logout: 'ਲੌਗ ਆਉਟ',
        profile_logoutTitle: 'ਲੌਗ ਆਉਟ ਕਰੋ?',
        profile_logoutMsg: 'ਤੁਹਾਨੂੰ ਆਪਣੇ ਖਾਤੇ ਤੱਕ ਪਹੁੰਚਣ ਲਈ ਦੁਬਾਰਾ ਸਾਈਨ ਇਨ ਕਰਨਾ ਹੋਵੇਗਾ।',
        profile_cancel: 'ਰੱਦ ਕਰੋ',
        profile_logoutConfirm: 'ਹਾਂ, ਲੌਗ ਆਉਟ ਕਰੋ',

        notFound_message: 'ਪੰਨਾ ਨਹੀਂ ਮਿਲਿਆ',
        notFound_goHome: 'ਹੋਮ ਤੇ ਜਾਓ',

        slogan_pageTitle: 'ਸਲੋਗਨ ਮੁਕਾਬਲਾ',
        slogan_contestLabel: 'ਗ੍ਰੈਂਡ ਪ੍ਰਾਈਜ਼ ਮੁਕਾਬਲਾ',
        slogan_enterTitle: 'ਆਪਣਾ ਸਲੋਗਨ ਦਰਜ ਕਰੋ',
        slogan_enterSubtitle: 'ਭਾਗ ਲੈਣ ਅਤੇ ਵੱਡਾ ਜਿੱਤਣ ਲਈ ਆਪਣਾ ਰਚਨਾਤਮਕ ਸਲੋਗਨ ਜਮ੍ਹਾਂ ਕਰੋ!',
        slogan_inputLabel: 'ਮੈਨੂੰ ਇਹ Agrosatva ਦੀ ਬੋਤਲ ਵਿੱਚ ਮਿਲਿਆ / ਮਿਲੀ।',
        slogan_placeholder: 'ਇੱਥੇ ਆਪਣਾ ਸਲੋਗਨ ਲਿਖੋ...',
        slogan_submit: 'ਸਲੋਗਨ ਜਮ੍ਹਾਂ ਕਰੋ',
        slogan_submitting: 'ਜਮ੍ਹਾਂ ਹੋ ਰਿਹਾ ਹੈ...',
        slogan_errEmpty: 'ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਸਲੋਗਨ ਦਰਜ ਕਰੋ।',
        slogan_errFailed: 'ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।',
        slogan_alreadyTitle: 'ਤੁਸੀਂ ਮੁਕਾਬਲੇ ਵਿੱਚ ਹੋ!',
        slogan_alreadyMsg: 'ਸਾਨੂੰ ਗ੍ਰੈਂਡ ਪ੍ਰਾਈਜ਼ ਮੁਕਾਬਲੇ ਲਈ ਤੁਹਾਡੀ ਐਂਟਰੀ ਮਿਲ ਚੁੱਕੀ ਹੈ। ਮੁਕਾਬਲਾ ਖਤਮ ਹੋਣ ਤੋਂ ਬਾਅਦ ਨਤੀਜੇ ਐਲਾਨ ਕੀਤੇ ਜਾਣਗੇ!',
        slogan_goHome: 'ਹੋਮ ਤੇ ਜਾਓ',

        redeem_pageTitle: 'ਕਮਾਈ ਵੇਖੋ',
        redeem_balance: 'ਬੈਲੇਂਸ',
        redeem_totalEarned: 'ਕੁੱਲ ਕਮਾਈ',
        redeem_transferred: 'ਟ੍ਰਾਂਸਫਰ ਕੀਤਾ',
        redeem_transferFunds: 'ਫੰਡ ਟ੍ਰਾਂਸਫਰ ਕਰੋ',
        redeem_upiId: 'UPI ID',
        redeem_bankAccount: 'ਬੈਂਕ ਖਾਤਾ',
        redeem_tabEarned: 'ਕਮਾਇਆ',
        redeem_tabTransferred: 'ਟ੍ਰਾਂਸਫਰ',
        redeem_noTransactions: 'ਕੋਈ ਲੈਣ-ਦੇਣ ਨਹੀਂ',
        redeem_errNoBalance: 'ਟ੍ਰਾਂਸਫਰ ਕਰਨ ਲਈ ਕੋਈ ਬੈਲੇਂਸ ਉਪਲਬਧ ਨਹੀਂ ਹੈ',

        scan_pageTitle: 'ਕੋਡ ਸਕੈਨ ਕਰੋ',
        scan_pointCamera: 'QR ਕੋਡ ਤੇ ਕੈਮਰਾ ਨਿਰਦੇਸ਼ਿਤ ਕਰੋ',
        scan_cameraUnavailable: 'ਕੈਮਰਾ ਉਪਲਬਧ ਨਹੀਂ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਹੇਠਾਂ ਮੈਨੂਅਲ ਐਂਟਰੀ ਵਰਤੋ।',
        scan_orEnterManually: 'ਜਾਂ ਮੈਨੂਅਲ ਦਰਜ ਕਰੋ',
        scan_placeholder: 'CB45SYR463F',
        scan_submitCode: 'ਕੋਡ ਜਮ੍ਹਾਂ ਕਰੋ',
        scan_congrats: 'ਵਧਾਈ ਹੋਵੇ!',
        scan_youEarned: 'ਤੁਸੀਂ ਕਮਾਇਆ ਹੈ',
        scan_cashbackRewards: 'ਇੱਕ ਕੈਸ਼ਬੈਕ ਰਿਵਾਰਡ',
        scan_viewEarnings: 'ਹੁਣੇ ਟ੍ਰਾਂਸਫਰ ਕਰੋ',
        scan_scanAnother: 'ਦੂਜਾ ਕੋਡ ਸਕੈਨ ਕਰੋ',
        scan_grandPrizeBtn: 'ਗ੍ਰੈਂਡ ਪ੍ਰਾਈਜ਼ ਮੁਕਾਬਲੇ ਵਿੱਚ ਦਾਖਲ ਹੋਵੋ',
        scan_voucherVerified: 'ਵਾਊਚਰ ਤਸਦੀਕ ਹੋਇਆ',
        scan_contestSubmitted: 'ਮੁਕਾਬਲਾ ਐਂਟਰੀ ਜਮ੍ਹਾਂ ✅',
        scan_contestSubmittedMsg: 'ਵਧਾਈ! ਤੁਸੀਂ ਗ੍ਰੈਂਡ ਪ੍ਰਾਈਜ਼ ਮੁਕਾਬਲੇ ਲਈ ਯੋਗ ਹੋ। ਮੁਕਾਬਲਾ ਖਤਮ ਹੋਣ ਤੋਂ ਬਾਅਦ ਨਤੀਜੇ ਘੋਸ਼ਿਤ ਕੀਤੇ ਜਾਣਗੇ।',
        scan_contestNotSubmitted: 'ਮੁਕਾਬਲਾ ਐਂਟਰੀ ਜਮ੍ਹਾਂ ਨਹੀਂ ਹੋਈ',
        scan_contestNotSubmittedMsg: 'ਭਾਗ ਲੈਣ ਲਈ ਆਪਣਾ ਸਲੋਗਨ ਜਮ੍ਹਾਂ ਕਰੋ!',
        scan_submitSlogan: 'ਸਲੋਗਨ ਜਮ੍ਹਾਂ ਕਰੋ',
        scan_verificationFailed: 'ਤਸਦੀਕ ਅਸਫਲ',
        scan_tryAgain: 'ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ',
        scan_errInvalid: 'ਗਲਤ ਵਾਊਚਰ ਕੋਡ।',
        scan_errUsed: 'ਇਹ ਵਾਊਚਰ ਪਹਿਲਾਂ ਹੀ ਵਰਤਿਆ ਜਾ ਚੁੱਕਾ ਹੈ।',
        scan_errAssigned: 'ਇਹ ਵਾਊਚਰ ਪਹਿਲਾਂ ਹੀ ਅਸਾਈਨ ਹੋ ਚੁੱਕਾ ਹੈ।',
        scan_errExpired: 'ਇਹ ਵਾਊਚਰ ਮਿਆਦ ਪੁੱਗ ਗਈ ਹੈ।',
        scan_errSuccess: 'ਵਾਊਚਰ ਸਫਲਤਾਪੂਰਵਕ ਤਸਦੀਕ ਹੋਇਆ!',

        bank_pageTitle: 'ਬੈਂਕ ਵੇਰਵੇ',
        bank_addTitle: 'ਬੈਂਕ ਖਾਤਾ ਜੋੜੋ',
        bank_ifscLabel: 'IFSC ਕੋਡ',
        bank_ifscPlaceholder: 'ਜਿਵੇਂ SBIN0001234',
        bank_accountLabel: 'ਖਾਤਾ ਨੰਬਰ',
        bank_accountPlaceholder: 'ਖਾਤਾ ਨੰਬਰ ਦਰਜ ਕਰੋ',
        bank_confirmLabel: 'ਖਾਤਾ ਦੁਬਾਰਾ ਦਰਜ ਕਰੋ',
        bank_confirmPlaceholder: 'ਖਾਤਾ ਨੰਬਰ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ',
        bank_addBtn: 'ਖਾਤਾ ਜੋੜੋ',
        bank_transferBtn: 'ਰਕਮ ਟ੍ਰਾਂਸਫਰ ਕਰੋ',
        bank_addAnotherBtn: 'ਦੂਜਾ ਖਾਤਾ ਜੋੜੋ',
        bank_holderName: 'ਖਾਤਾਧਾਰਕ',
        bank_accountNumber: 'ਖਾਤਾ ਨੰਬਰ',
        bank_ifscCode: 'IFSC ਕੋਡ',
        bank_bankName: 'ਬੈਂਕ ਦਾ ਨਾਮ',
        bank_default: 'ਡਿਫੌਲਟ',
        bank_setDefault: 'ਡਿਫੌਲਟ ਸੈੱਟ ਕਰੋ',
        bank_delete: 'ਮਿਟਾਓ',
        bank_errFillAll: 'ਕਿਰਪਾ ਕਰਕੇ ਸਾਰੇ ਫੀਲਡ ਭਰੋ',
        bank_errMismatch: 'ਖਾਤਾ ਨੰਬਰ ਮੇਲ ਨਹੀਂ ਖਾਂਦੇ',
        bank_errInvalidIfsc: 'ਗਲਤ IFSC ਕੋਡ',
        bank_errVerifyFailed: 'ਖਾਤਾ ਤਸਦੀਕ ਅਸਫਲ',
        bank_errVerifyError: 'ਤਸਦੀਕ ਗਲਤੀ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।',
        bank_errIfscFetch: 'ਬੈਂਕ ਵੇਰਵੇ ਪ੍ਰਾਪਤ ਕਰਨ ਵਿੱਚ ਗਲਤੀ',
        bank_successAdded: 'ਬੈਂਕ ਖਾਤਾ ਸਫਲਤਾਪੂਰਵਕ ਜੋੜਿਆ ਗਿਆ',
        bank_successDeleted: 'ਖਾਤਾ ਮਿਟਾਇਆ ਗਿਆ',
        bank_successDefault: 'ਡਿਫੌਲਟ ਖਾਤਾ ਅੱਪਡੇਟ ਕੀਤਾ ਗਿਆ',

        upi_pageTitle: 'UPI ਵੇਰਵੇ',
        upi_mobileLabel: 'ਮੋਬਾਈਲ ਨੰਬਰ (UPI)',
        upi_mobilePlaceholder: 'ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ',
        upi_verifiedLabel: 'ਸਫਲਤਾਪੂਰਵਕ ਤਸਦੀਕ',
        upi_name: 'ਨਾਮ',
        upi_upiId: 'UPI ID',
        upi_mobile: 'ਮੋਬਾਈਲ',
        upi_btnWait: 'ਕਿਰਪਾ ਉਡੀਕ ਕਰੋ...',
        upi_btnProceed: 'ਅੱਗੇ ਵਧੋ',
        upi_btnVerify: 'ਮੋਬਾਈਲ ਨੰਬਰ ਤਸਦੀਕ ਕਰੋ',
        upi_errInvalidMobile: 'ਇੱਕ ਵੈਧ 10 ਅੰਕਾਂ ਦਾ ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ',
        upi_successVerified: 'ਮੋਬਾਈਲ ਨੰਬਰ ਸਫਲਤਾਪੂਰਵਕ ਤਸਦੀਕ!',
        upi_errFailed: 'ਮੋਬਾਈਲ ਨੰਬਰ ਤਸਦੀਕ ਅਸਫਲ',
        upi_errGeneric: 'ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।',

        confirm_pageTitle: 'ਭੁਗਤਾਨ ਵੇਰਵੇ',
        confirm_transferAmount: 'ਟ੍ਰਾਂਸਫਰ ਰਕਮ',
        confirm_noBalance: 'ਟ੍ਰਾਂਸਫਰ ਕਰਨ ਲਈ ਕੋਈ ਬੈਲੇਂਸ ਉਪਲਬਧ ਨਹੀਂ',
        confirm_vouchersLabel: 'ਰਿਡੀਮ ਕਰਨ ਲਈ ਵਾਊਚਰ',
        confirm_paymentMethod: 'ਭੁਗਤਾਨ ਵਿਧੀ',
        confirm_upi: 'UPI',
        confirm_bankTransfer: 'ਬੈਂਕ ਟ੍ਰਾਂਸਫਰ',
        confirm_bank: 'ਬੈਂਕ',
        confirm_account: 'ਖਾਤਾ',
        confirm_ifsc: 'IFSC',
        confirm_name: 'ਨਾਮ',
        confirm_btnNoBalance: 'ਕੋਈ ਬੈਲੇਂਸ ਉਪਲਬਧ ਨਹੀਂ',
        confirm_btnConfirm: 'ਪੁਸ਼ਟੀ ਕਰੋ ਅਤੇ ਟ੍ਰਾਂਸਫਰ ਕਰੋ',
        confirm_errGeneric: 'ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।',
        confirm_popupLabel: 'ਸਫਲ',
        confirm_popupTitle:
            "ਤੁਹਾਡੀ ਬੇਨਤੀ ਸਫਲਤਾਪੂਰਵਕ ਭੇਜੀ ਗਈ ਹੈ। ਭੁਗਤਾਨ 2 ਘੰਟਿਆਂ ਦੇ ਅੰਦਰ ਪ੍ਰੋਸੈਸ ਕੀਤਾ ਜਾਵੇਗਾ।",
        confirm_popupMsg:
            "ਸ਼ਾਮ 6 ਵਜੇ ਤੋਂ ਬਾਅਦ ਕੀਤੀਆਂ ਬੇਨਤੀਆਂ ਅਗਲੇ ਕੰਮਕਾਜ ਦੇ ਦਿਨ ਪ੍ਰੋਸੈਸ ਕੀਤੀਆਂ ਜਾਣਗੀਆਂ।",
        confirm_popupTotal: 'ਕੁੱਲ ਰਿਡੀਮ',
        confirm_warningTitle: '⚠ ਟ੍ਰਾਂਸਫਰ ਲੰਬਿਤ',
        confirm_warningMsg: 'ਇੱਕ ਅੰਦਰੂਨੀ ਸਮੱਸਿਆ ਕਾਰਨ ਰਕਮ ਤੁਰੰਤ ਤੁਹਾਡੇ ਖਾਤੇ ਵਿੱਚ ਟ੍ਰਾਂਸਫਰ ਨਹੀਂ ਹੋ ਸਕੀ। ਸਾਡੀ ਟੀਮ ਜਲਦੀ ਹੀ ਇਸਨੂੰ ਪ੍ਰੋਸੈਸ ਕਰੇਗੀ। ਜੇ ਲੋੜ ਹੋਵੇ ਤਾਂ ਸਹਾਇਤਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।',
        confirm_done: 'ਹੋ ਗਿਆ',

        home_welcome: 'ਜੀ ਆਇਆਂ',
        home_totalEarned: 'ਕੁੱਲ ਕਮਾਈ',
        home_transferred: 'ਟ੍ਰਾਂਸਫਰ',
        home_balance: 'ਬੈਲੇਂਸ',
        home_viewEarnings: 'ਕਮਾਈ ਵੇਖੋ',
        home_grandPrizeBtn: 'ਗ੍ਰੈਂਡ ਪ੍ਰਾਈਜ਼ ਮੁਕਾਬਲੇ ਵਿੱਚ ਜਾਓ',
        home_promoTitle: 'ਪ੍ਰੋਮੋ ਕੋਡ',
        home_promoSubtitle: 'ਆਪਣੇ Agrosatva ਪੈਕ ਤੋਂ QR ਸਕੈਨ ਕਰੋ ਜਾਂ ਕੋਡ ਦਰਜ ਕਰੋ',
        home_scanBtn: 'ਸਕੈਨ / ਕੋਡ ਦਰਜ ਕਰੋ',
        home_enterCodeTitle: 'ਵਾਊਚਰ ਕੋਡ ਦਰਜ ਕਰੋ',
        home_enterCodePlaceholder: 'ਕੋਡ ਦਰਜ ਕਰੋ',
        home_submit: 'ਜਮ੍ਹਾਂ ਕਰੋ',
        home_alreadyAssignedTitle: 'ਵਾਊਚਰ ਪਹਿਲਾਂ ਹੀ ਅਸਾਈਨ ਹੈ!',
        home_tryAnother: 'ਦੂਜਾ ਕੂਪਨ ਅਜ਼ਮਾਓ',
        home_congrats: 'ਵਧਾਈ ਹੋਵੇ!',
        home_youEarned: 'ਤੁਸੀਂ ਕਮਾਇਆ ਹੈ',
        home_cashbackRewards: 'ਇੱਕ ਕੈਸ਼ਬੈਕ ਰਿਵਾਰਡ',
        home_viewEarningsBtn: "ਕਮਾਈ ਪ੍ਰਾਪਤ ਕਰੋ",
        home_scanAnother: 'ਦੂਜਾ ਕੋਡ ਸਕੈਨ ਕਰੋ',
        home_inContestTitle: 'ਤੁਸੀਂ ਮੁਕਾਬਲੇ ਵਿੱਚ ਹੋ',
        home_congratsTitle: 'ਵਧਾਈ ਹੋਵੇ',
        home_contestReceivedMsg: 'ਸਾਨੂੰ ਗ੍ਰੈਂਡ ਪ੍ਰਾਈਜ਼ ਮੁਕਾਬਲੇ ਲਈ ਤੁਹਾਡੀ ਪ੍ਰਵਿਸ਼ਟੀ ਮਿਲ ਚੁੱਕੀ ਹੈ। ਮੁਕਾਬਲਾ ਖਤਮ ਹੋਣ ਤੋਂ ਬਾਅਦ ਨਤੀਜੇ ਘੋਸ਼ਿਤ ਕੀਤੇ ਜਾਣਗੇ!',
        home_scanMoreBtn: 'ਹੋਰ ਜਿੱਤਣ ਲਈ ਦੂਜਾ ਕੂਪਨ ਸਕੈਨ ਕਰੋ',
        home_goHome: 'ਹੋਮ ਤੇ ਜਾਓ',
        home_eligibleMsg: 'ਤੁਸੀਂ ਗ੍ਰੈਂਡ ਪ੍ਰਾਈਜ਼ ਮੁਕਾਬਲੇ ਲਈ ਯੋਗ ਹੋ। ਕਿਰਪਾ ਕਰਕੇ ਮੁਕਾਬਲੇ ਵਿੱਚ ਭਾਗ ਲੈਣ ਲਈ ਹੇਠਾਂ ਦਿੱਤੇ ਲਿੰਕ ਤੇ ਕਲਿੱਕ ਕਰੋ',
        home_participate: 'ਭਾਗ ਲਓ',
        home_verificationFailed: 'ਤਸਦੀਕ ਅਸਫਲ',
        home_tryAgain: 'ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ',
        home_errInvalid: 'ਗਲਤ ਵਾਊਚਰ ਕੋਡ।',
        home_errUsed: 'ਇਹ ਵਾਊਚਰ ਪਹਿਲਾਂ ਹੀ ਵਰਤਿਆ ਜਾ ਚੁੱਕਾ ਹੈ।',
        home_errMaxLimit: 'ਤੁਸੀਂ 10 ਵਾਊਚਰ ਦੀ ਅਧਿਕਤਮ ਸੀਮਾ ਪਾਰ ਕਰ ਲਈ ਹੈ।',
        home_errAssignedMine: 'ਇਹ ਵਾਊਚਰ ਪਹਿਲਾਂ ਹੀ ਤੁਹਾਡੇ ਖਾਤੇ ਵਿੱਚ ਹੈ।',
        home_errAssignedOther: 'ਇਹ ਵਾਊਚਰ ਪਹਿਲਾਂ ਹੀ ਕਿਸੇ ਹੋਰ ਉਪਭੋਗਤਾ ਨੂੰ ਅਸਾਈਨ ਹੈ।',
        home_errExpired: 'ਇਹ ਵਾਊਚਰ ਮਿਆਦ ਪੁੱਗ ਗਈ ਹੈ।',
        home_errSuccess: 'ਵਾਊਚਰ ਸਫਲਤਾਪੂਰਵਕ ਤਸਦੀਕ ਹੋਇਆ!',
        slogan_popupLabel: 'ਜਮ੍ਹਾਂ ਹੋ ਗਿਆ!',
        slogan_popupTitle: 'ਧੰਨਵਾਦ!',
        slogan_popupMsg: 'ਤੁਹਾਡਾ ਸਲੋਗਨ ਸਫਲਤਾਪੂਰਵਕ ਜਮ੍ਹਾਂ ਹੋ ਗਿਆ ਹੈ ਅਤੇ ਤੁਸੀਂ ਗ੍ਰੈਂਡ ਪ੍ਰਾਈਜ਼ ਮੁਕਾਬਲੇ ਦਾ ਹਿੱਸਾ ਬਣ ਗਏ ਹੋ। ਨਤੀਜਿਆਂ ਦੀ ਉਡੀਕ ਕਰੋ!',
        appTitle: 'ਜੈਨਕ੍ਰੈਸਟ ਐਗਰੋਸਤਵਾ',
        appDescription: 'ਟਿਕਾਊ ਖੇਤੀ ਹੱਲ',

        game_betterLuck: "ਅਗਲੀ ਵਾਰ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
        game_spinAndWin: "🎡 ਸਪਿਨ ਅਤੇ ਜਿੱਤੋ",
        game_spin: "ਸਪਿਨ",
        game_congratulations: "🎉 ਮੁਬਾਰਕਾਂ!",
        game_youWon: "ਤੁਸੀਂ ਜਿੱਤਿਆ",
        game_dontWorry: "ਚਿੰਤਾ ਨਾ ਕਰੋ, ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ!",
        game_dashboard: "ਡੈਸ਼ਬੋਰਡ ਤੇ ਵਾਪਸ ਜਾਓ",
        game_playAgain: "ਫਿਰ ਤੋਂ ਖੇਡੋ",
        game_luckyGame: "ਲੱਕੀ ਗੇਮ",
        game_Desc: "ਚੱਕਰ ਘੁਮਾਓ ਅਤੇ ਤੁਰੰਤ ਸ਼ਾਨਦਾਰ ਇਨਾਮ ਜਿੱਤੋ।",
        game_points: "ਪੌਇੰਟਸ"
    },
    mr: {
        welcome: "स्वागत आहे शेतकरी", enterMobile: "पुढे जाण्यासाठी मोबाइल नंबर प्रविष्ट करा",
        mobileLabel: "मोबाइल नंबर", mobilePlaceholder: "10 अंकी मोबाइल नंबर प्रविष्ट करा",
        termsText: "मी मान्य करतो/करते", termsLink: "अटी व शर्ती",
        submit: "सबमिट करा", sendingOtp: "OTP पाठवत आहे...", invalidMobile: "अवैध मोबाइल नंबर",
        otpSentTo: "कोड पाठवला +91", loginWithOtp: "OTP ने लॉगिन करा",
        otpSentMessage: "OTP पाठवले +91",
        otpError: "कृपया OTP चे सर्व 4 अंक प्रविष्ट करा",
        invalidOtp: "चुकीचा OTP. कृपया पुन्हा प्रयत्न करा.",
        login: "लॉगिन", verifying: "सत्यापित होत आहे...",
        resendOtp: "OTP पुन्हा पाठवा", otpResent: "OTP पुन्हा पाठवला",
        footer: "शाश्वत शेती उपाय",
        profile_heading: "प्रोफाइल पूर्ण करा",
        profile_subheading: "पुढे जाण्यासाठी प्रोफाइल पूर्ण करा",
        profile_nameLabel: "पूर्ण नाव", profile_namePlaceholder: "तुमचे पूर्ण नाव प्रविष्ट करा",
        profile_pincodeLabel: "पिनकोड", profile_pincodePlaceholder: "6 अंकी पिनकोड प्रविष्ट करा",
        profile_stateLabel: "राज्य", profile_districtLabel: "जिल्हा",
        profile_villageLabel: "गाव", profile_acreageLabel: "एकूण एकर",
        profile_acreagePlaceholder: "उदा. 12",
        profile_autoFill: "पिनकोडवरून आपोआप भरले जाईल",
        profile_infoNote: "कृपया सर्व तपशील काळजीपूर्वक भरा. हे नंतर बदलता येणार नाही.",
        profile_saveBtn: "जतन करा आणि पुढे जा",
        profile_saved: "प्रोफाइल यशस्वीरित्या जतन केली!",
        profile_saveError: "काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा.",
        profile_invalidPincode: "अवैध पिनकोड",
        profile_pincodeError: "पिनकोड तपशील मिळवता आले नाहीत",
        profile_errName: "कृपया तुमचे नाव प्रविष्ट करा",
        profile_errPincode: "वैध 6 अंकी पिनकोड प्रविष्ट करा",
        profile_errLocation: "स्थान भरण्यासाठी वैध पिनकोड प्रविष्ट करा",
        profile_errAcreage: "कृपया एकूण एकर प्रविष्ट करा",
        profile_errAge: "कृपया वय प्रविष्ट करा",
        profile_ageLabel: "वय",

        profile_myProfile: 'माझी प्रोफाइल',
        profile_locationDetails: 'स्थान तपशील',
        profile_farmDetails: 'शेत तपशील',
        profile_state: 'राज्य',
        profile_district: 'जिल्हा',
        profile_village: 'गाव',
        profile_pincode: 'पिनकोड',
        profile_totalAcreage: 'एकूण एकर',
        profile_acres: 'एकर',
        profile_noticeText: 'प्रोफाइल तपशील सत्यापित आहेत आणि बदलले जाऊ शकत नाहीत. कोणत्याही सुधारणांसाठी सपोर्टशी संपर्क करा.',
        profile_backToDashboard: 'डॅशबोर्डवर परत जा',
        profile_logout: 'लॉग आउट',
        profile_logoutTitle: 'लॉग आउट करायचे?',
        profile_logoutMsg: 'तुमच्या खात्यात प्रवेश करण्यासाठी तुम्हाला पुन्हा साइन इन करावे लागेल.',
        profile_cancel: 'रद्द करा',
        profile_logoutConfirm: 'होय, लॉग आउट करा',

        notFound_message: 'पृष्ठ सापडले नाही',
        notFound_goHome: 'होमवर जा',

        slogan_pageTitle: 'घोषवाक्य स्पर्धा',
        slogan_contestLabel: 'ग्रँड प्राइझ स्पर्धा',
        slogan_enterTitle: 'तुमचे घोषवाक्य सादर करा',
        slogan_enterSubtitle: 'सहभागी होण्यासाठी आणि मोठे जिंकण्यासाठी तुमचे सर्जनशील घोषवाक्य सबमिट करा!',
        slogan_inputLabel: 'मला हे Agrosatva च्या बाटलीत मिळाले / मिळाली.',
        slogan_placeholder: 'येथे तुमचे घोषवाक्य लिहा...',
        slogan_submit: 'घोषवाक्य सबमिट करा',
        slogan_submitting: 'सबमिट होत आहे...',
        slogan_errEmpty: 'कृपया तुमचे घोषवाक्य प्रविष्ट करा.',
        slogan_errFailed: 'काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा.',
        slogan_alreadyTitle: 'तुम्ही स्पर्धेत आहात!',
        slogan_alreadyMsg: 'ग्रँड प्राइझ स्पर्धेसाठी आमच्याकडे आधीच तुमची नोंद प्राप्त झाली आहे. स्पर्धा संपल्यावर निकाल जाहीर केले जातील!',
        slogan_goHome: 'होमवर जा',

        redeem_pageTitle: 'कमाई पहा',
        redeem_balance: 'शिल्लक',
        redeem_totalEarned: 'एकूण कमाई',
        redeem_transferred: 'हस्तांतरित',
        redeem_transferFunds: 'निधी हस्तांतरित करा',
        redeem_upiId: 'UPI ID',
        redeem_bankAccount: 'बँक खाते',
        redeem_tabEarned: 'मिळवले',
        redeem_tabTransferred: 'हस्तांतरित',
        redeem_noTransactions: 'कोणताही व्यवहार नाही',
        redeem_errNoBalance: 'हस्तांतरणासाठी कोणतेही शिल्लक उपलब्ध नाही',

        scan_pageTitle: 'कोड स्कॅन करा',
        scan_pointCamera: 'QR कोडवर कॅमेरा निर्देशित करा',
        scan_cameraUnavailable: 'कॅमेरा उपलब्ध नाही. कृपया खाली मॅन्युअल एंट्री वापरा.',
        scan_orEnterManually: 'किंवा मॅन्युअल प्रविष्ट करा',
        scan_placeholder: 'CB45SYR463F',
        scan_submitCode: 'कोड सबमिट करा',
        scan_congrats: 'अभिनंदन!',
        scan_youEarned: 'तुम्ही मिळवले आहे',
        scan_cashbackRewards: 'एक कॅशबॅक रिवॉर्ड',
        scan_viewEarnings: 'आत्ता ट्रान्सफर करा',
        scan_scanAnother: 'दुसरा कोड स्कॅन करा',
        scan_grandPrizeBtn: 'ग्रँड प्राइझ स्पर्धेत सहभागी व्हा',
        scan_voucherVerified: 'व्हाउचर सत्यापित',
        scan_contestSubmitted: 'स्पर्धा नोंदणी सबमिट ✅',
        scan_contestSubmittedMsg: 'अभिनंदन! तुम्ही ग्रँड प्राइझ स्पर्धेसाठी पात्र आहात. स्पर्धा संपल्यावर निकाल जाहीर केले जातील.',
        scan_contestNotSubmitted: 'स्पर्धा नोंदणी सबमिट नाही',
        scan_contestNotSubmittedMsg: 'सहभागी होण्यासाठी तुमचे घोषवाक्य सबमिट करा!',
        scan_submitSlogan: 'घोषवाक्य सबमिट करा',
        scan_verificationFailed: 'सत्यापन अयशस्वी',
        scan_tryAgain: 'पुन्हा प्रयत्न करा',
        scan_errInvalid: 'अवैध व्हाउचर कोड.',
        scan_errUsed: 'हा व्हाउचर आधीच वापरला गेला आहे.',
        scan_errAssigned: 'हा व्हाउचर आधीच नियुक्त केला गेला आहे.',
        scan_errExpired: 'हा व्हाउचर कालबाह्य झाला आहे.',
        scan_errSuccess: 'व्हाउचर यशस्वीरित्या सत्यापित!',

        bank_pageTitle: 'बँक तपशील',
        bank_addTitle: 'बँक खाते जोडा',
        bank_ifscLabel: 'IFSC कोड',
        bank_ifscPlaceholder: 'उदा. SBIN0001234',
        bank_accountLabel: 'खाते क्रमांक',
        bank_accountPlaceholder: 'खाते क्रमांक प्रविष्ट करा',
        bank_confirmLabel: 'खाते पुन्हा प्रविष्ट करा',
        bank_confirmPlaceholder: 'खाते क्रमांक पुष्टी करा',
        bank_addBtn: 'खाते जोडा',
        bank_transferBtn: 'रक्कम हस्तांतरित करा',
        bank_addAnotherBtn: 'दुसरे खाते जोडा',
        bank_holderName: 'खातेधारक',
        bank_accountNumber: 'खाते क्रमांक',
        bank_ifscCode: 'IFSC कोड',
        bank_bankName: 'बँकेचे नाव',
        bank_default: 'डीफॉल्ट',
        bank_setDefault: 'डीफॉल्ट सेट करा',
        bank_delete: 'हटवा',
        bank_errFillAll: 'कृपया सर्व फील्ड भरा',
        bank_errMismatch: 'खाते क्रमांक जुळत नाहीत',
        bank_errInvalidIfsc: 'अवैध IFSC कोड',
        bank_errVerifyFailed: 'खाते सत्यापन अयशस्वी',
        bank_errVerifyError: 'सत्यापन त्रुटी. कृपया पुन्हा प्रयत्न करा.',
        bank_errIfscFetch: 'बँक तपशील मिळवताना त्रुटी',
        bank_successAdded: 'बँक खाते यशस्वीरित्या जोडले',
        bank_successDeleted: 'खाते हटवले',
        bank_successDefault: 'डीफॉल्ट खाते अपडेट केले',

        upi_pageTitle: 'UPI तपशील',
        upi_mobileLabel: 'मोबाइल नंबर (UPI)',
        upi_mobilePlaceholder: 'मोबाइल नंबर प्रविष्ट करा',
        upi_verifiedLabel: 'यशस्वीरित्या सत्यापित',
        upi_name: 'नाव',
        upi_upiId: 'UPI ID',
        upi_mobile: 'मोबाइल',
        upi_btnWait: 'कृपया प्रतीक्षा करा...',
        upi_btnProceed: 'पुढे जा',
        upi_btnVerify: 'मोबाइल नंबर सत्यापित करा',
        upi_errInvalidMobile: 'वैध 10 अंकी मोबाइल नंबर प्रविष्ट करा',
        upi_successVerified: 'मोबाइल नंबर यशस्वीरित्या सत्यापित!',
        upi_errFailed: 'मोबाइल नंबर सत्यापन अयशस्वी',
        upi_errGeneric: 'काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा.',

        confirm_pageTitle: 'पेमेंट तपशील',
        confirm_transferAmount: 'हस्तांतरण रक्कम',
        confirm_noBalance: 'हस्तांतरणासाठी कोणतेही शिल्लक नाही',
        confirm_vouchersLabel: 'रिडीम करण्याचे व्हाउचर',
        confirm_paymentMethod: 'पेमेंट पद्धत',
        confirm_upi: 'UPI',
        confirm_bankTransfer: 'बँक हस्तांतरण',
        confirm_bank: 'बँक',
        confirm_account: 'खाते',
        confirm_ifsc: 'IFSC',
        confirm_name: 'नाव',
        confirm_btnNoBalance: 'कोणतेही शिल्लक नाही',
        confirm_btnConfirm: 'पुष्टी करा आणि हस्तांतरित करा',
        confirm_errGeneric: 'काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा.',
        confirm_popupLabel: 'यशस्वी',
        confirm_popupTitle:
            "तुमची विनंती यशस्वीपणे सबमिट झाली आहे. पेमेंट 2 तासांच्या आत प्रोसेस केले जाईल.",
        confirm_popupMsg:
            "संध्याकाळी 6 नंतर केलेल्या विनंत्या पुढील कामकाजाच्या दिवशी प्रोसेस केल्या जातील.",
        confirm_popupTotal: 'एकूण रिडीम',
        confirm_warningTitle: '⚠ हस्तांतरण प्रलंबित',
        confirm_warningMsg: 'अंतर्गत समस्येमुळे रक्कम तात्काळ तुमच्या खात्यात हस्तांतरित होऊ शकली नाही. आमची टीम लवकरच ते प्रोसेस करेल. आवश्यक असल्यास सपोर्टशी संपर्क करा.',
        confirm_done: 'झाले',

        home_welcome: 'स्वागत',
        home_totalEarned: 'एकूण कमाई',
        home_transferred: 'हस्तांतरित',
        home_balance: 'शिल्लक',
        home_viewEarnings: 'कमाई पहा',
        home_grandPrizeBtn: 'ग्रँड प्राइझ स्पर्धेत जा',
        home_promoTitle: 'प्रोमो कोड',
        home_promoSubtitle: 'तुमच्या Agrosatva पॅकमधून QR स्कॅन करा किंवा कोड प्रविष्ट करा',
        home_scanBtn: 'स्कॅन / कोड प्रविष्ट करा',
        home_enterCodeTitle: 'व्हाउचर कोड प्रविष्ट करा',
        home_enterCodePlaceholder: 'कोड प्रविष्ट करा',
        home_submit: 'सबमिट',
        home_alreadyAssignedTitle: 'व्हाउचर आधीच नियुक्त आहे!',
        home_tryAnother: 'दुसरा कूपन वापरून पहा',
        home_congrats: 'अभिनंदन!',
        home_youEarned: 'तुम्ही मिळवले आहे',
        home_cashbackRewards: 'एक कॅशबॅक रिवॉर्ड',
        home_viewEarningsBtn: "कमाई मिळवा",
        home_scanAnother: 'दुसरा कोड स्कॅन करा',
        home_inContestTitle: 'तुम्ही स्पर्धेत आहात',
        home_congratsTitle: 'अभिनंदन',
        home_contestReceivedMsg: 'ग्रँड प्राइझ स्पर्धेसाठी आमच्याकडे आधीच तुमची नोंद आली आहे. स्पर्धा संपल्यावर निकाल जाहीर केले जातील!',
        home_scanMoreBtn: 'अधिक जिंकण्यासाठी दुसरा कूपन स्कॅन करा',
        home_goHome: 'होमवर जा',
        home_eligibleMsg: 'तुम्ही ग्रँड प्राइझ स्पर्धेसाठी पात्र आहात. कृपया स्पर्धेत सहभागी होण्यासाठी खालील लिंकवर क्लिक करा',
        home_participate: 'सहभागी व्हा',
        home_verificationFailed: 'सत्यापन अयशस्वी',
        home_tryAgain: 'पुन्हा प्रयत्न करा',
        home_errInvalid: 'अवैध व्हाउचर कोड.',
        home_errUsed: 'हा व्हाउचर आधीच वापरला गेला आहे.',
        home_errMaxLimit: 'तुम्ही 10 व्हाउचरची कमाल मर्यादा गाठली आहे.',
        home_errAssignedMine: 'हा व्हाउचर आधीच तुमच्या खात्यात आहे.',
        home_errAssignedOther: 'हा व्हाउचर आधीच दुसऱ्या वापरकर्त्याला नियुक्त आहे.',
        home_errExpired: 'हा व्हाउचर कालबाह्य झाला आहे.',
        home_errSuccess: 'व्हाउचर यशस्वीरित्या सत्यापित!',
        slogan_popupLabel: 'सबमिट झाले!',
        slogan_popupTitle: 'धन्यवाद!',
        slogan_popupMsg: 'तुमचे घोषवाक्य यशस्वीरित्या सबमिट झाले आहे आणि तुम्ही ग्रँड प्राइझ स्पर्धेचा भाग झालात. निकालाची वाट पाहा!',
        appTitle: 'जेनक्रेस्ट एग्रोसत्वा',
        appDescription: 'शाश्वत शेती उपाय',

        game_betterLuck: "पुढच्या वेळी प्रयत्न करा",
        game_spinAndWin: "🎡 फिरवा आणि जिंका",
        game_spin: "फिरवा",
        game_congratulations: "🎉 अभिनंदन!",
        game_youWon: "तुम्ही जिंकलात",
        game_dontWorry: "काळजी करू नका, पुन्हा प्रयत्न करा!",
        game_dashboard: "डॅशबोर्डवर परत जा",
        game_playAgain: "पुन्हा खेळा",
        game_luckyGame: "लकी गेम",
        game_Desc: "चक्र फिरवा आणि लगेच आकर्षक बक्षिसे जिंका.",
        game_points: "पॉइंट्स"
    },
    gu: {
        welcome: "સ્વાગત છે ખેડૂત", enterMobile: "આગળ વધવા માટે મોબાઇલ નંબર દાખલ કરો",
        mobileLabel: "મોબાઇલ નંબર", mobilePlaceholder: "10 અંકનો મોબાઇલ નંબર દાખલ કરો",
        termsText: "હું સ્વીકારું છું", termsLink: "નિયમો અને શરતો",
        submit: "સબમિટ કરો", sendingOtp: "OTP મોકલાઈ રહ્યો છે...", invalidMobile: "અમાન્ય મોબાઇલ નંબર",
        otpSentTo: "કોડ મોકલ્યો +91", loginWithOtp: "OTP થી લૉગિન કરો",
        otpSentMessage: "OTP મોકલ્યો +91",
        otpError: "કૃપા કરીને OTP ના બધા 4 અંક દાખલ કરો",
        invalidOtp: "ખોટો OTP. કૃપા કરીને ફરી પ્રયાસ કરો.",
        login: "લૉગિન", verifying: "ચકાસણી થઈ રહી છે...",
        resendOtp: "OTP ફરી મોકલો", otpResent: "OTP ફરી મોકલ્યો",
        footer: "ટકાઉ ખેતી ઉકેલો",
        profile_heading: "પ્રોફાઇલ પૂર્ણ કરો",
        profile_subheading: "આગળ વધવા માટે પ્રોફાઇલ પૂર્ણ કરો",
        profile_nameLabel: "પૂરું નામ", profile_namePlaceholder: "તમારું પૂરું નામ દાખલ કરો",
        profile_pincodeLabel: "પિનકોડ", profile_pincodePlaceholder: "6 અંકનો પિનકોડ દાખલ કરો",
        profile_stateLabel: "રાજ્ય", profile_districtLabel: "જિલ્લો",
        profile_villageLabel: "ગામ", profile_acreageLabel: "કુલ એકર",
        profile_acreagePlaceholder: "દા.ત. 12",
        profile_autoFill: "પિનકોડ પરથી આપોઆપ ભરાશે",
        profile_infoNote: "કૃપા કરીને બધી વિગતો કાળજીપૂર્વક ભરો. આ પછીથી બદલી શકાશે નહીં.",
        profile_saveBtn: "સાચવો અને આગળ વધો",
        profile_saved: "પ્રોફાઇલ સફળતાપૂર્વક સાચવાઈ!",
        profile_saveError: "કંઈક ખોટું થયું. કૃપા કરીને ફરી પ્રયાસ કરો.",
        profile_invalidPincode: "અમાન્ય પિનકોડ",
        profile_pincodeError: "પિનકોડ વિગતો મળી શકી નહીં",
        profile_errName: "કૃપા કરીને તમારું નામ દાખલ કરો",
        profile_errPincode: "માન્ય 6 અંકનો પિનકોડ દાખલ કરો",
        profile_errLocation: "સ્થાન ભરવા માટે માન્ય પિનકોડ દાખલ કરો",
        profile_errAcreage: "કૃપા કરીને કુલ એકર દાખલ કરો",
        profile_errAge: "કૃપા કરીને ઉંમર દાખલ કરો",
        profile_ageLabel: "ઉંમર",

        profile_myProfile: 'મારી પ્રોફાઇલ',
        profile_locationDetails: 'સ્થાન વિગતો',
        profile_farmDetails: 'ખેતર વિગતો',
        profile_state: 'રાજ્ય',
        profile_district: 'જિલ્લો',
        profile_village: 'ગામ',
        profile_pincode: 'પિનકોડ',
        profile_totalAcreage: 'કુલ એકર',
        profile_acres: 'એકર',
        profile_noticeText: 'પ્રોફાઇલ વિગતો ચકાસેલ છે અને બદલી શકાતી નથી. કોઈ પણ સુધારા માટે સપોર્ટનો સંપર્ક કરો.',
        profile_backToDashboard: 'ડેશબોર્ડ પર પાછા જાઓ',
        profile_logout: 'લૉગ આઉટ',
        profile_logoutTitle: 'લૉગ આઉટ કરવું?',
        profile_logoutMsg: 'તમારા એકાઉન્ટ સુધી પહોંચવા માટે તમારે ફરીથી સાઇન ઇન કરવું પડશે.',
        profile_cancel: 'રદ કરો',
        profile_logoutConfirm: 'હા, લૉગ આઉટ કરો',

        notFound_message: 'પૃષ્ઠ મળ્યું નથી',
        notFound_goHome: 'હોમ પર જાઓ',

        slogan_pageTitle: 'સ્લોગન સ્પર્ધા',
        slogan_contestLabel: 'ગ્રાન્ડ પ્રાઇઝ સ્પર્ધા',
        slogan_enterTitle: 'તમારો સ્લોગન દાખલ કરો',
        slogan_enterSubtitle: 'ભાગ લેવા અને મોટું જીતવા માટે તમારો સર્જનાત્મક સ્લોગન સબમિટ કરો!',
        slogan_inputLabel: 'મને આ Agrosatva ની બોટલમાં મળ્યું / મળ્યાં.',
        slogan_placeholder: 'અહીં તમારો સ્લોગન લખો...',
        slogan_submit: 'સ્લોગન સબમિટ કરો',
        slogan_submitting: 'સબમિટ થઈ રહ્યો છે...',
        slogan_errEmpty: 'કૃપા કરીને તમારો સ્લોગન દાખલ કરો.',
        slogan_errFailed: 'કંઈક ખોટું થયું. કૃપા કરીને ફરી પ્રયાસ કરો.',
        slogan_alreadyTitle: 'તમે સ્પર્ધામાં છો!',
        slogan_alreadyMsg: 'ગ્રાન્ડ પ્રાઇઝ સ્પર્ધા માટે અમને તમારી એન્ટ્રી મળી ગઈ છે. સ્પર્ધા સમાપ્ત થયા પછી પરિણામ જાહેર કરવામાં આવશે!',
        slogan_goHome: 'હોમ પર જાઓ',

        redeem_pageTitle: 'કમાણી જુઓ',
        redeem_balance: 'બેલેન્સ',
        redeem_totalEarned: 'કુલ કમાણી',
        redeem_transferred: 'ટ્રાન્સફર કર્યું',
        redeem_transferFunds: 'ફંડ ટ્રાન્સફર કરો',
        redeem_upiId: 'UPI ID',
        redeem_bankAccount: 'બેંક ખાતું',
        redeem_tabEarned: 'કમાયેલ',
        redeem_tabTransferred: 'ટ્રાન્સફર',
        redeem_noTransactions: 'કોઈ વ્યવહાર નથી',
        redeem_errNoBalance: 'ટ્રાન્સફર કરવા માટે કોઈ બેલેન્સ ઉપલબ્ધ નથી',

        scan_pageTitle: 'કોડ સ્કૅન કરો',
        scan_pointCamera: 'QR કોડ પર કેમેરો નિર્દેશ કરો',
        scan_cameraUnavailable: 'કેમેરો ઉપલબ્ધ નથી. કૃપા કરીને નીચે મૅન્યુઅલ એન્ટ્રી વાપરો.',
        scan_orEnterManually: 'અથવા મૅન્યુઅલ દાખલ કરો',
        scan_placeholder: 'CB45SYR463F',
        scan_submitCode: 'કોડ સબમિટ કરો',
        scan_congrats: 'અભિનંદન!',
        scan_youEarned: 'તમે કમાયા છો',
        scan_cashbackRewards: 'એક કૅશબૅક રિવૉર્ડ',
        scan_viewEarnings: 'હવે ટ્રાન્સફર કરો',
        scan_scanAnother: 'બીજો કોડ સ્કૅન કરો',
        scan_grandPrizeBtn: 'ગ્રાન્ડ પ્રાઇઝ સ્પર્ધામાં ભાગ લો',
        scan_voucherVerified: 'વાઉચર ચકાસાયું',
        scan_contestSubmitted: 'સ્પર્ધા પ્રવેશ સબમિટ ✅',
        scan_contestSubmittedMsg: 'અભિનંદન! તમે ગ્રાન્ડ પ્રાઇઝ સ્પર્ધા માટે પાત્ર છો. સ્પર્ધા સમાપ્ત થયા પછી પરિણામ જાહેર કરવામાં આવશે.',
        scan_contestNotSubmitted: 'સ્પર્ધા પ્રવેશ સબમિટ નથી',
        scan_contestNotSubmittedMsg: 'ભાગ લેવા માટે તમારો સ્લોગન સબમિટ કરો!',
        scan_submitSlogan: 'સ્લોગન સબમિટ કરો',
        scan_verificationFailed: 'ચકાસણી નિષ્ફળ',
        scan_tryAgain: 'ફરી પ્રયાસ કરો',
        scan_errInvalid: 'અમાન્ય વાઉચર કોડ.',
        scan_errUsed: 'આ વાઉચર પહેલેથી વપરાઈ ગયો છે.',
        scan_errAssigned: 'આ વાઉચર પહેલેથી સોંપાઈ ગયો છે.',
        scan_errExpired: 'આ વાઉચરની મુદત પૂરી થઈ ગઈ છે.',
        scan_errSuccess: 'વાઉચર સફળતાપૂર્વક ચકાસાયું!',

        bank_pageTitle: 'બેંક વિગતો',
        bank_addTitle: 'બેંક ખાતું ઉમેરો',
        bank_ifscLabel: 'IFSC કોડ',
        bank_ifscPlaceholder: 'દા.ત. SBIN0001234',
        bank_accountLabel: 'ખાતા નંબર',
        bank_accountPlaceholder: 'ખાતા નંબર દાખલ કરો',
        bank_confirmLabel: 'ખાતું ફરી દાખલ કરો',
        bank_confirmPlaceholder: 'ખાતા નંબરની પુષ્ટિ કરો',
        bank_addBtn: 'ખાતું ઉમેરો',
        bank_transferBtn: 'રકમ ટ્રાન્સફર કરો',
        bank_addAnotherBtn: 'બીજું ખાતું ઉમેરો',
        bank_holderName: 'ખાતાધારક',
        bank_accountNumber: 'ખાતા નંબર',
        bank_ifscCode: 'IFSC કોડ',
        bank_bankName: 'બેંકનું નામ',
        bank_default: 'ડિફૉલ્ટ',
        bank_setDefault: 'ડિફૉલ્ટ સેટ કરો',
        bank_delete: 'કાઢી નાખો',
        bank_errFillAll: 'કૃપા કરીને બધા ક્ષેત્રો ભરો',
        bank_errMismatch: 'ખાતા નંબર મેળ ખાતા નથી',
        bank_errInvalidIfsc: 'અમાન્ય IFSC કોડ',
        bank_errVerifyFailed: 'ખાતા ચકાસણી નિષ્ફળ',
        bank_errVerifyError: 'ચકાસણી ભૂલ. કૃપા કરીને ફરી પ્રયાસ કરો.',
        bank_errIfscFetch: 'બેંક વિગતો મેળવવામાં ભૂલ',
        bank_successAdded: 'બેંક ખાતું સફળતાપૂર્વક ઉમેરવામાં આવ્યું',
        bank_successDeleted: 'ખાતું કાઢી નાખ્યું',
        bank_successDefault: 'ડિફૉલ્ટ ખાતું અપડેટ કર્યું',

        upi_pageTitle: 'UPI વિગતો',
        upi_mobileLabel: 'મોબાઇલ નંબર (UPI)',
        upi_mobilePlaceholder: 'મોબાઇલ નંબર દાખલ કરો',
        upi_verifiedLabel: 'સફળતાપૂર્વક ચકાસાયું',
        upi_name: 'નામ',
        upi_upiId: 'UPI ID',
        upi_mobile: 'મોબાઇલ',
        upi_btnWait: 'કૃપા કરી રાહ જુઓ...',
        upi_btnProceed: 'આગળ વધો',
        upi_btnVerify: 'મોબાઇલ નંબર ચકાસો',
        upi_errInvalidMobile: 'માન્ય 10 અંકનો મોબાઇલ નંબર દાખલ કરો',
        upi_successVerified: 'મોબાઇલ નંબર સફળતાપૂર્વક ચકાસાયું!',
        upi_errFailed: 'મોબાઇલ નંબર ચકાસણી નિષ્ફળ',
        upi_errGeneric: 'કંઈક ખોટું થયું. કૃપા કરીને ફરી પ્રયાસ કરો.',

        confirm_pageTitle: 'ચુકવણી વિગતો',
        confirm_transferAmount: 'ટ્રાન્સફર રકમ',
        confirm_noBalance: 'ટ્રાન્સફર કરવા માટે કોઈ બેલેન્સ નથી',
        confirm_vouchersLabel: 'રિડીમ કરવા માટેના વાઉચર',
        confirm_paymentMethod: 'ચુકવણી પદ્ધતિ',
        confirm_upi: 'UPI',
        confirm_bankTransfer: 'બેંક ટ્રાન્સફર',
        confirm_bank: 'બેંક',
        confirm_account: 'ખાતું',
        confirm_ifsc: 'IFSC',
        confirm_name: 'નામ',
        confirm_btnNoBalance: 'કોઈ બેલેન્સ ઉપલબ્ધ નથી',
        confirm_btnConfirm: 'પુષ્ટિ કરો અને ટ્રાન્સફર કરો',
        confirm_errGeneric: 'કંઈક ખોટું થયું. કૃપા કરીને ફરી પ્રયાસ કરો.',
        confirm_popupLabel: 'સફળ',
        confirm_popupTitle:
            "તમારી વિનંતી સફળતાપૂર્વક સબમિટ થઈ ગઈ છે. ચુકવણી 2 કલાકની અંદર પ્રક્રિયા કરવામાં આવશે.",
        confirm_popupMsg:
            "સાંજે 6 વાગ્યા પછી કરેલી વિનંતીઓ આગળના કામકાજના દિવસે પ્રક્રિયા કરવામાં આવશે.",
        confirm_popupTotal: 'કુલ રિડીમ',
        confirm_warningTitle: '⚠ ટ્રાન્સફર બાકી',
        confirm_warningMsg: 'આંતરિક સમસ્યાને કારણે રકમ તાત્કાલિક તમારા ખાતામાં ટ્રાન્સફર થઈ શકી નથી. અમારી ટીમ ટૂંક સમયમાં પ્રોસેસ કરશે. જો જરૂર હોય તો સપોર્ટ સાથે સંપર્ક કરો.',
        confirm_done: 'થઈ ગયું',

        home_welcome: 'સ્વાગત',
        home_totalEarned: 'કુલ કમાણી',
        home_transferred: 'ટ્રાન્સફર',
        home_balance: 'બેલેન્સ',
        home_viewEarnings: 'કમાણી જુઓ',
        home_grandPrizeBtn: 'ગ્રાન્ડ પ્રાઇઝ સ્પર્ધામાં જાઓ',
        home_promoTitle: 'પ્રોમો કોડ',
        home_promoSubtitle: 'તમારા Agrosatva પૅકમાંથી QR સ્કૅન કરો અથવા કોડ દાખલ કરો',
        home_scanBtn: 'સ્કૅન / કોડ દાખલ કરો',
        home_enterCodeTitle: 'વાઉચર કોડ દાખલ કરો',
        home_enterCodePlaceholder: 'કોડ દાખલ કરો',
        home_submit: 'સબમિટ',
        home_alreadyAssignedTitle: 'વાઉચર પહેલેથી સોંપાઈ ગયો છે!',
        home_tryAnother: 'બીજો કૂપન અજમાવો',
        home_congrats: 'અભિનંદન!',
        home_youEarned: 'તમે કમાયા છો',
        home_cashbackRewards: 'એક કૅશબૅક રિવૉર્ડ',
        home_viewEarningsBtn: "કમાણી મેળવો",
        home_scanAnother: 'બીજો કોડ સ્કૅન કરો',
        home_inContestTitle: 'તમે સ્પર્ધામાં છો',
        home_congratsTitle: 'અભિનંદન',
        home_contestReceivedMsg: 'ગ્રાન્ડ પ્રાઇઝ સ્પર્ધા માટે અમને તમારી એન્ટ્રી મળી ગઈ છે. સ્પર્ધા સમાપ્ત થયા પછી પરિણામ જાહેર કરવામાં આવશે!',
        home_scanMoreBtn: 'વધુ જીતવા બીજો કૂપન સ્કૅન કરો',
        home_goHome: 'હોમ પર જાઓ',
        home_eligibleMsg: 'તમે ગ્રાન્ડ પ્રાઇઝ સ્પર્ધા માટે પાત્ર છો. કૃપા કરી સ્પર્ધામાં ભાગ લેવા નીચેની લિંક પર ક્લિક કરો',
        home_participate: 'ભાગ લો',
        home_verificationFailed: 'ચકાસણી નિષ્ફળ',
        home_tryAgain: 'ફરી પ્રયાસ કરો',
        home_errInvalid: 'અમાન્ય વાઉચર કોડ.',
        home_errUsed: 'આ વાઉચર પહેલેથી વપરાઈ ગયો છે.',
        home_errMaxLimit: 'તમે 10 વાઉચરની મહત્તમ મર્યાદા પહોંચ્યા છો.',
        home_errAssignedMine: 'આ વાઉચર પહેલેથી તમારા ખાતામાં છે.',
        home_errAssignedOther: 'આ વાઉચર પહેલેથી બીજા વપરાશકારને સોંપાઈ ગયો છે.',
        home_errExpired: 'આ વાઉચરની મુદત પૂરી થઈ ગઈ છે.',
        home_errSuccess: 'વાઉચર સફળતાપૂર્વક ચકાસાયું!',
        slogan_popupLabel: 'સબમિટ થઈ ગયું!',
        slogan_popupTitle: 'આભાર!',
        slogan_popupMsg: 'તમારો સ્લોગન સફળતાપૂર્વક સબમિટ થઈ ગયો છે અને તમે ગ્રાન્ડ પ્રાઇઝ સ્પર્ધાનો ભાગ બની ગયા છો. પરિણામની રાહ જુઓ!',
        appTitle: 'જેનક્રેસ્ટ એગ્રોસત્વા',
        appDescription: 'ટકાઉ ખેતી ઉકેલો',

        game_betterLuck: "આગામી વખતે પ્રયત્ન કરો",
        game_spinAndWin: "🎡 સ્પિન અને જીતો",
        game_spin: "સ્પિન",
        game_congratulations: "🎉 અભિનંદન!",
        game_youWon: "તમે જીત્યા",
        game_dontWorry: "ચિંતા કરશો નહીં, ફરી પ્રયત્ન કરો!",
        game_dashboard: "ડેશબોર્ડ પર પાછા જાઓ",
        game_playAgain: "ફરી રમો",
        game_luckyGame: "લકી ગેમ",
        game_Desc: "વ્હીલ ફેરવો અને તરત જ આકર્ષક ઇનામો જીતી લો.",
        game_points: "પોઈન્ટ્સ"
    },
    kn: {
        welcome: "ಸ್ವಾಗತ ರೈತ", enterMobile: "ಮುಂದುವರೆಯಲು ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
        mobileLabel: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ", mobilePlaceholder: "10 ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
        termsText: "ನಾನು ಒಪ್ಪುತ್ತೇನೆ", termsLink: "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
        submit: "ಸಲ್ಲಿಸು", sendingOtp: "OTP ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ...", invalidMobile: "ಅಮಾನ್ಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
        otpSentTo: "ಕೋಡ್ ಕಳುಹಿಸಲಾಗಿದೆ +91", loginWithOtp: "OTP ನಿಂದ ಲಾಗಿನ್ ಮಾಡಿ",
        otpSentMessage: "OTP ಕಳುಹಿಸಲಾಗಿದೆ +91",
        otpError: "ದಯವಿಟ್ಟು OTP ನ ಎಲ್ಲಾ 4 ಅಂಕಿಗಳನ್ನು ನಮೂದಿಸಿ",
        invalidOtp: "ತಪ್ಪಾದ OTP. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
        login: "ಲಾಗಿನ್", verifying: "ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ...",
        resendOtp: "OTP ಮರಳಿ ಕಳುಹಿಸಿ", otpResent: "OTP ಮರಳಿ ಕಳುಹಿಸಲಾಗಿದೆ",
        footer: "ಸುಸ್ಥಿರ ಕೃಷಿ ಪರಿಹಾರಗಳು",
        profile_heading: "ಪ್ರೊಫೈಲ್ ಪೂರ್ಣಗೊಳಿಸಿ",
        profile_subheading: "ಮುಂದುವರೆಯಲು ಪ್ರೊಫೈಲ್ ಪೂರ್ಣಗೊಳಿಸಿ",
        profile_nameLabel: "ಪೂರ್ಣ ಹೆಸರು", profile_namePlaceholder: "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
        profile_pincodeLabel: "ಪಿನ್‌ಕೋಡ್", profile_pincodePlaceholder: "6 ಅಂಕಿಯ ಪಿನ್‌ಕೋಡ್ ನಮೂದಿಸಿ",
        profile_stateLabel: "ರಾಜ್ಯ", profile_districtLabel: "ಜಿಲ್ಲೆ",
        profile_villageLabel: "ಗ್ರಾಮ", profile_acreageLabel: "ಒಟ್ಟು ಎಕರೆ",
        profile_acreagePlaceholder: "ಉದಾ. 12",
        profile_autoFill: "ಪಿನ್‌ಕೋಡ್‌ನಿಂದ ಸ್ವಯಂ ತುಂಬಲಾಗುತ್ತದೆ",
        profile_infoNote: "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ವಿವರಗಳನ್ನು ಎಚ್ಚರಿಕೆಯಿಂದ ಭರ್ತಿ ಮಾಡಿ. ಇವುಗಳನ್ನು ನಂತರ ಬದಲಾಯಿಸಲಾಗುವುದಿಲ್ಲ.",
        profile_saveBtn: "ಉಳಿಸಿ ಮತ್ತು ಮುಂದುವರೆಯಿರಿ",
        profile_saved: "ಪ್ರೊಫೈಲ್ ಯಶಸ್ವಿಯಾಗಿ ಉಳಿಸಲಾಗಿದೆ!",
        profile_saveError: "ಏನೋ ತಪ್ಪಾಯಿತು. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
        profile_invalidPincode: "ಅಮಾನ್ಯ ಪಿನ್‌ಕೋಡ್",
        profile_pincodeError: "ಪಿನ್‌ಕೋಡ್ ವಿವರಗಳನ್ನು ಪಡೆಯಲಾಗಲಿಲ್ಲ",
        profile_errName: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
        profile_errPincode: "ಮಾನ್ಯ 6 ಅಂಕಿಯ ಪಿನ್‌ಕೋಡ್ ನಮೂದಿಸಿ",
        profile_errLocation: "ಸ್ಥಳ ತುಂಬಲು ಮಾನ್ಯ ಪಿನ್‌ಕೋಡ್ ನಮೂದಿಸಿ",
        profile_errAcreage: "ದಯವಿಟ್ಟು ಒಟ್ಟು ಎಕರೆ ನಮೂದಿಸಿ",
        profile_errAge: "ದಯವಿಟ್ಟು ವಯಸ್ಸನ್ನು ನಮೂದಿಸಿ",
        profile_ageLabel: "ವಯಸ್ಸು",

        profile_myProfile: 'ನನ್ನ ಪ್ರೊಫೈಲ್',
        profile_locationDetails: 'ಸ್ಥಳ ವಿವರಗಳು',
        profile_farmDetails: 'ಜಮೀನು ವಿವರಗಳು',
        profile_state: 'ರಾಜ್ಯ',
        profile_district: 'ಜಿಲ್ಲೆ',
        profile_village: 'ಗ್ರಾಮ',
        profile_pincode: 'ಪಿನ್‌ಕೋಡ್',
        profile_totalAcreage: 'ಒಟ್ಟು ಎಕರೆ',
        profile_acres: 'ಎಕರೆ',
        profile_noticeText: 'ಪ್ರೊಫೈಲ್ ವಿವರಗಳನ್ನು ಪರಿಶೀಲಿಸಲಾಗಿದ್ದು ಬದಲಾಯಿಸಲಾಗುವುದಿಲ್ಲ. ಯಾವುದೇ ತಿದ್ದುಪಡಿಗಾಗಿ ಸಪೋರ್ಟ್ ಅನ್ನು ಸಂಪರ್ಕಿಸಿ.',
        profile_backToDashboard: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ಗೆ ಹಿಂದಿರುಗಿ',
        profile_logout: 'ಲಾಗ್ ಔಟ್',
        profile_logoutTitle: 'ಲಾಗ್ ಔಟ್ ಮಾಡುವಿರಾ?',
        profile_logoutMsg: 'ನಿಮ್ಮ ಖಾತೆಯನ್ನು ಪ್ರವೇಶಿಸಲು ನೀವು ಮತ್ತೆ ಸೈನ್ ಇನ್ ಮಾಡಬೇಕಾಗುತ್ತದೆ.',
        profile_cancel: 'ರದ್ದುಮಾಡಿ',
        profile_logoutConfirm: 'ಹೌದು, ಲಾಗ್ ಔಟ್ ಮಾಡಿ',

        notFound_message: 'ಪುಟ ಕಂಡುಬಂದಿಲ್ಲ',
        notFound_goHome: 'ಹೋಮ್‌ಗೆ ಹೋಗಿ',

        slogan_pageTitle: 'ಸ್ಲೋಗನ್ ಸ್ಪರ್ಧೆ',
        slogan_contestLabel: 'ಗ್ರ್ಯಾಂಡ್ ಪ್ರೈಜ್ ಸ್ಪರ್ಧೆ',
        slogan_enterTitle: 'ನಿಮ್ಮ ಸ್ಲೋಗನ್ ನಮೂದಿಸಿ',
        slogan_enterSubtitle: 'ಭಾಗವಹಿಸಲು ಮತ್ತು ದೊಡ್ಡದನ್ನು ಗೆಲ್ಲಲು ನಿಮ್ಮ ಸೃಜನಾತ್ಮಕ ಸ್ಲೋಗನ್ ಸಲ್ಲಿಸಿ!',
        slogan_inputLabel: 'ನನಗೆ ಇದು Agrosatva ಬಾಟಲಿಯಲ್ಲಿ ಸಿಕ್ಕಿತು.',
        slogan_placeholder: 'ಇಲ್ಲಿ ನಿಮ್ಮ ಸ್ಲೋಗನ್ ಬರೆಯಿರಿ...',
        slogan_submit: 'ಸ್ಲೋಗನ್ ಸಲ್ಲಿಸಿ',
        slogan_submitting: 'ಸಲ್ಲಿಸಲಾಗುತ್ತಿದೆ...',
        slogan_errEmpty: 'ದಯವಿಟ್ಟು ನಿಮ್ಮ ಸ್ಲೋಗನ್ ನಮೂದಿಸಿ.',
        slogan_errFailed: 'ಏನೋ ತಪ್ಪಾಯಿತು. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
        slogan_alreadyTitle: 'ನೀವು ಸ್ಪರ್ಧೆಯಲ್ಲಿದ್ದೀರಿ!',
        slogan_alreadyMsg: 'ಗ್ರ್ಯಾಂಡ್ ಪ್ರೈಜ್ ಸ್ಪರ್ಧೆಗೆ ನಿಮ್ಮ ಎಂಟ್ರಿ ನಮಗೆ ಈಗಾಗಲೇ ತಲುಪಿದೆ. ಸ್ಪರ್ಧೆ ಮುಗಿದ ನಂತರ ಫಲಿತಾಂಶ ಘೋಷಿಸಲಾಗುವುದು!',
        slogan_goHome: 'ಹೋಮ್‌ಗೆ ಹೋಗಿ',

        redeem_pageTitle: 'ಗಳಿಕೆ ನೋಡಿ',
        redeem_balance: 'ಬ್ಯಾಲೆನ್ಸ್',
        redeem_totalEarned: 'ಒಟ್ಟು ಗಳಿಕೆ',
        redeem_transferred: 'ವರ್ಗಾಯಿಸಲಾಗಿದೆ',
        redeem_transferFunds: 'ಹಣ ವರ್ಗಾಯಿಸಿ',
        redeem_upiId: 'UPI ID',
        redeem_bankAccount: 'ಬ್ಯಾಂಕ್ ಖಾತೆ',
        redeem_tabEarned: 'ಗಳಿಸಿದ್ದು',
        redeem_tabTransferred: 'ವರ್ಗಾವಣೆ',
        redeem_noTransactions: 'ವ್ಯವಹಾರಗಳಿಲ್ಲ',
        redeem_errNoBalance: 'ವರ್ಗಾಯಿಸಲು ಯಾವುದೇ ಬ್ಯಾಲೆನ್ಸ್ ಇಲ್ಲ',

        scan_pageTitle: 'ಕೋಡ್ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ',
        scan_pointCamera: 'QR ಕೋಡ್‌ಗೆ ಕ್ಯಾಮೆರಾ ಗುರಿಪಡಿಸಿ',
        scan_cameraUnavailable: 'ಕ್ಯಾಮೆರಾ ಲಭ್ಯವಿಲ್ಲ. ದಯವಿಟ್ಟು ಕೆಳಗೆ ಮ್ಯಾನ್ಯುಯಲ್ ಎಂಟ್ರಿ ಬಳಸಿ.',
        scan_orEnterManually: 'ಅಥವಾ ಮ್ಯಾನ್ಯುಯಲ್ ನಮೂದಿಸಿ',
        scan_placeholder: 'CB45SYR463F',
        scan_submitCode: 'ಕೋಡ್ ಸಲ್ಲಿಸಿ',
        scan_congrats: 'ಅಭಿನಂದನೆಗಳು!',
        scan_youEarned: 'ನೀವು ಗಳಿಸಿದ್ದೀರಿ',
        scan_cashbackRewards: 'ಒಂದು ಕ್ಯಾಶ್‌ಬ್ಯಾಕ್ ರಿವಾರ್ಡ್',
        scan_viewEarnings: 'ಈಗಲೇ ವರ್ಗಾಯಿಸಿ',
        scan_scanAnother: 'ಮತ್ತೊಂದು ಕೋಡ್ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ',
        scan_grandPrizeBtn: 'ಗ್ರ್ಯಾಂಡ್ ಪ್ರೈಜ್ ಸ್ಪರ್ಧೆಗೆ ಸೇರಿ',
        scan_voucherVerified: 'ವೌಚರ್ ಪರಿಶೀಲಿಸಲಾಗಿದೆ',
        scan_contestSubmitted: 'ಸ್ಪರ್ಧೆ ಎಂಟ್ರಿ ಸಲ್ಲಿಸಲಾಗಿದೆ ✅',
        scan_contestSubmittedMsg: 'ಅಭಿನಂದನೆ! ನೀವು ಗ್ರ್ಯಾಂಡ್ ಪ್ರೈಜ್ ಸ್ಪರ್ಧೆಗೆ ಅರ್ಹರಾಗಿದ್ದೀರಿ. ಸ್ಪರ್ಧೆ ಮುಗಿದ ನಂತರ ಫಲಿತಾಂಶ ಘೋಷಿಸಲಾಗುವುದು.',
        scan_contestNotSubmitted: 'ಸ್ಪರ್ಧೆ ಎಂಟ್ರಿ ಸಲ್ಲಿಸಿಲ್ಲ',
        scan_contestNotSubmittedMsg: 'ಭಾಗವಹಿಸಲು ನಿಮ್ಮ ಸ್ಲೋಗನ್ ಸಲ್ಲಿಸಿ!',
        scan_submitSlogan: 'ಸ್ಲೋಗನ್ ಸಲ್ಲಿಸಿ',
        scan_verificationFailed: 'ಪರಿಶೀಲನೆ ವಿಫಲವಾಗಿದೆ',
        scan_tryAgain: 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
        scan_errInvalid: 'ಅಮಾನ್ಯ ವೌಚರ್ ಕೋಡ್.',
        scan_errUsed: 'ಈ ವೌಚರ್ ಈಗಾಗಲೇ ಬಳಸಲಾಗಿದೆ.',
        scan_errAssigned: 'ಈ ವೌಚರ್ ಈಗಾಗಲೇ ನಿಯೋಜಿಸಲಾಗಿದೆ.',
        scan_errExpired: 'ಈ ವೌಚರ್ ಅವಧಿ ಮೀರಿದೆ.',
        scan_errSuccess: 'ವೌಚರ್ ಯಶಸ್ವಿಯಾಗಿ ಪರಿಶೀಲಿಸಲಾಗಿದೆ!',

        bank_pageTitle: 'ಬ್ಯಾಂಕ್ ವಿವರಗಳು',
        bank_addTitle: 'ಬ್ಯಾಂಕ್ ಖಾತೆ ಸೇರಿಸಿ',
        bank_ifscLabel: 'IFSC ಕೋಡ್',
        bank_ifscPlaceholder: 'ಉದಾ. SBIN0001234',
        bank_accountLabel: 'ಖಾತೆ ಸಂಖ್ಯೆ',
        bank_accountPlaceholder: 'ಖಾತೆ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ',
        bank_confirmLabel: 'ಖಾತೆ ಮರು-ನಮೂದಿಸಿ',
        bank_confirmPlaceholder: 'ಖಾತೆ ಸಂಖ್ಯೆ ದೃಢೀಕರಿಸಿ',
        bank_addBtn: 'ಖಾತೆ ಸೇರಿಸಿ',
        bank_transferBtn: 'ಮೊತ್ತ ವರ್ಗಾಯಿಸಿ',
        bank_addAnotherBtn: 'ಮತ್ತೊಂದು ಖಾತೆ ಸೇರಿಸಿ',
        bank_holderName: 'ಖಾತೆದಾರ',
        bank_accountNumber: 'ಖಾತೆ ಸಂಖ್ಯೆ',
        bank_ifscCode: 'IFSC ಕೋಡ್',
        bank_bankName: 'ಬ್ಯಾಂಕ್ ಹೆಸರು',
        bank_default: 'ಡೀಫಾಲ್ಟ್',
        bank_setDefault: 'ಡೀಫಾಲ್ಟ್ ಆಗಿ ಹೊಂದಿಸಿ',
        bank_delete: 'ಅಳಿಸಿ',
        bank_errFillAll: 'ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಕ್ಷೇತ್ರಗಳನ್ನು ತುಂಬಿರಿ',
        bank_errMismatch: 'ಖಾತೆ ಸಂಖ್ಯೆಗಳು ಹೊಂದಾಣಿಕೆಯಾಗುತ್ತಿಲ್ಲ',
        bank_errInvalidIfsc: 'ಅಮಾನ್ಯ IFSC ಕೋಡ್',
        bank_errVerifyFailed: 'ಖಾತೆ ಪರಿಶೀಲನೆ ವಿಫಲ',
        bank_errVerifyError: 'ಪರಿಶೀಲನೆ ದೋಷ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
        bank_errIfscFetch: 'ಬ್ಯಾಂಕ್ ವಿವರಗಳನ್ನು ಪಡೆಯುವಲ್ಲಿ ದೋಷ',
        bank_successAdded: 'ಬ್ಯಾಂಕ್ ಖಾತೆ ಯಶಸ್ವಿಯಾಗಿ ಸೇರಿಸಲಾಗಿದೆ',
        bank_successDeleted: 'ಖಾತೆ ಅಳಿಸಲಾಗಿದೆ',
        bank_successDefault: 'ಡೀಫಾಲ್ಟ್ ಖಾತೆ ನವೀಕರಿಸಲಾಗಿದೆ',

        upi_pageTitle: 'UPI ವಿವರಗಳು',
        upi_mobileLabel: 'ಮೊಬೈಲ್ ಸಂಖ್ಯೆ (UPI)',
        upi_mobilePlaceholder: 'ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ',
        upi_verifiedLabel: 'ಯಶಸ್ವಿಯಾಗಿ ಪರಿಶೀಲಿಸಲಾಗಿದೆ',
        upi_name: 'ಹೆಸರು',
        upi_upiId: 'UPI ID',
        upi_mobile: 'ಮೊಬೈಲ್',
        upi_btnWait: 'ದಯವಿಟ್ಟು ನಿರೀಕ್ಷಿಸಿ...',
        upi_btnProceed: 'ಮುಂದುವರೆಯಿರಿ',
        upi_btnVerify: 'ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಪರಿಶೀಲಿಸಿ',
        upi_errInvalidMobile: 'ಮಾನ್ಯ 10 ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ',
        upi_successVerified: 'ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಯಶಸ್ವಿಯಾಗಿ ಪರಿಶೀಲಿಸಲಾಗಿದೆ!',
        upi_errFailed: 'ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಪರಿಶೀಲನೆ ವಿಫಲ',
        upi_errGeneric: 'ಏನೋ ತಪ್ಪಾಯಿತು. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',

        confirm_pageTitle: 'ಪಾವತಿ ವಿವರಗಳು',
        confirm_transferAmount: 'ವರ್ಗಾವಣೆ ಮೊತ್ತ',
        confirm_noBalance: 'ವರ್ಗಾಯಿಸಲು ಯಾವುದೇ ಬ್ಯಾಲೆನ್ಸ್ ಇಲ್ಲ',
        confirm_vouchersLabel: 'ರಿಡೀಮ್ ಮಾಡಬೇಕಾದ ವೌಚರ್‌ಗಳು',
        confirm_paymentMethod: 'ಪಾವತಿ ವಿಧಾನ',
        confirm_upi: 'UPI',
        confirm_bankTransfer: 'ಬ್ಯಾಂಕ್ ವರ್ಗಾವಣೆ',
        confirm_bank: 'ಬ್ಯಾಂಕ್',
        confirm_account: 'ಖಾತೆ',
        confirm_ifsc: 'IFSC',
        confirm_name: 'ಹೆಸರು',
        confirm_btnNoBalance: 'ಯಾವುದೇ ಬ್ಯಾಲೆನ್ಸ್ ಇಲ್ಲ',
        confirm_btnConfirm: 'ದೃಢೀಕರಿಸಿ ಮತ್ತು ವರ್ಗಾಯಿಸಿ',
        confirm_errGeneric: 'ಏನೋ ತಪ್ಪಾಯಿತು. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
        confirm_popupLabel: 'ಯಶಸ್ವಿ',
        confirm_popupTitle:
            "ನಿಮ್ಮ ವಿನಂತಿ ಯಶಸ್ವಿಯಾಗಿ ಸಲ್ಲಿಸಲಾಗಿದೆ. ಪಾವತಿ 2 ಗಂಟೆಗಳ ಒಳಗೆ ಪ್ರಕ್ರಿಯೆಗೊಳ್ಳುತ್ತದೆ.",
        confirm_popupMsg:
            "ಸಂಜೆ 6 ಗಂಟೆಯ ನಂತರ ಸಲ್ಲಿಸಿದ ವಿನಂತಿಗಳನ್ನು ಮುಂದಿನ ಕೆಲಸದ ದಿನದಲ್ಲಿ ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತದೆ.",
        confirm_popupTotal: 'ಒಟ್ಟು ರಿಡೀಮ್',
        confirm_warningTitle: '⚠ ವರ್ಗಾವಣೆ ಬಾಕಿ',
        confirm_warningMsg: 'ಆಂತರಿಕ ಸಮಸ್ಯೆಯಿಂದ ಮೊತ್ತವನ್ನು ತಕ್ಷಣ ನಿಮ್ಮ ಖಾತೆಗೆ ವರ್ಗಾಯಿಸಲಾಗಲಿಲ್ಲ. ನಮ್ಮ ತಂಡ ಶೀಘ್ರದಲ್ಲೇ ಪ್ರಕ್ರಿಯೆಗೊಳಿಸುತ್ತದೆ. ಅಗತ್ಯವಿದ್ದರೆ ಸಪೋರ್ಟ್ ಅನ್ನು ಸಂಪರ್ಕಿಸಿ.',
        confirm_done: 'ಮುಗಿಯಿತು',

        home_welcome: 'ಸ್ವಾಗತ',
        home_totalEarned: 'ಒಟ್ಟು ಗಳಿಕೆ',
        home_transferred: 'ವರ್ಗಾವಣೆ',
        home_balance: 'ಬ್ಯಾಲೆನ್ಸ್',
        home_viewEarnings: 'ಗಳಿಕೆ ನೋಡಿ',
        home_grandPrizeBtn: 'ಗ್ರ್ಯಾಂಡ್ ಪ್ರೈಜ್ ಸ್ಪರ್ಧೆಗೆ ಹೋಗಿ',
        home_promoTitle: 'ಪ್ರೋಮೋ ಕೋಡ್',
        home_promoSubtitle: 'ನಿಮ್ಮ Agrosatva ಪ್ಯಾಕ್‌ನಿಂದ QR ಸ್ಕ್ಯಾನ್ ಮಾಡಿ ಅಥವಾ ಕೋಡ್ ನಮೂದಿಸಿ',
        home_scanBtn: 'ಸ್ಕ್ಯಾನ್ / ಕೋಡ್ ನಮೂದಿಸಿ',
        home_enterCodeTitle: 'ವೌಚರ್ ಕೋಡ್ ನಮೂದಿಸಿ',
        home_enterCodePlaceholder: 'ಕೋಡ್ ನಮೂದಿಸಿ',
        home_submit: 'ಸಲ್ಲಿಸಿ',
        home_alreadyAssignedTitle: 'ವೌಚರ್ ಈಗಾಗಲೇ ನಿಯೋಜಿಸಲಾಗಿದೆ!',
        home_tryAnother: 'ಮತ್ತೊಂದು ಕೂಪನ್ ಪ್ರಯತ್ನಿಸಿ',
        home_congrats: 'ಅಭಿನಂದನೆಗಳು!',
        home_youEarned: 'ನೀವು ಗಳಿಸಿದ್ದೀರಿ',
        home_cashbackRewards: 'ಒಂದು ಕ್ಯಾಶ್‌ಬ್ಯಾಕ್ ರಿವಾರ್ಡ್',
        home_viewEarningsBtn: "ಆದಾಯವನ್ನು ಪಡೆಯಿರಿ",
        home_scanAnother: 'ಮತ್ತೊಂದು ಕೋಡ್ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ',
        home_inContestTitle: 'ನೀವು ಸ್ಪರ್ಧೆಯಲ್ಲಿದ್ದೀರಿ',
        home_congratsTitle: 'ಅಭಿನಂದನೆ',
        home_contestReceivedMsg: 'ಗ್ರ್ಯಾಂಡ್ ಪ್ರೈಜ್ ಸ್ಪರ್ಧೆಗೆ ನಿಮ್ಮ ನೋಂದಣಿ ಈಗಾಗಲೇ ನಮಗೆ ತಲುಪಿದೆ. ಸ್ಪರ್ಧೆ ಮುಗಿದ ನಂತರ ಫಲಿತಾಂಶ ಘೋಷಿಸಲಾಗುವುದು!',
        home_scanMoreBtn: 'ಹೆಚ್ಚು ಗೆಲ್ಲಲು ಮತ್ತೊಂದು ಕೂಪನ್ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ',
        home_goHome: 'ಹೋಮ್‌ಗೆ ಹೋಗಿ',
        home_eligibleMsg: 'ನೀವು ಗ್ರ್ಯಾಂಡ್ ಪ್ರೈಜ್ ಸ್ಪರ್ಧೆಗೆ ಅರ್ಹರಾಗಿದ್ದೀರಿ. ಸ್ಪರ್ಧೆಯಲ್ಲಿ ಭಾಗವಹಿಸಲು ಕೆಳಗಿನ ಲಿಂಕ್ ಕ್ಲಿಕ್ ಮಾಡಿ',
        home_participate: 'ಭಾಗವಹಿಸಿ',
        home_verificationFailed: 'ಪರಿಶೀಲನೆ ವಿಫಲ',
        home_tryAgain: 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
        home_errInvalid: 'ಅಮಾನ್ಯ ವೌಚರ್ ಕೋಡ್.',
        home_errUsed: 'ಈ ವೌಚರ್ ಈಗಾಗಲೇ ಬಳಸಲಾಗಿದೆ.',
        home_errMaxLimit: 'ನೀವು 10 ವೌಚರ್‌ಗಳ ಗರಿಷ್ಠ ಮಿತಿ ತಲುಪಿದ್ದೀರಿ.',
        home_errAssignedMine: 'ಈ ವೌಚರ್ ಈಗಾಗಲೇ ನಿಮ್ಮ ಖಾತೆಯಲ್ಲಿದೆ.',
        home_errAssignedOther: 'ಈ ವೌಚರ್ ಈಗಾಗಲೇ ಇನ್ನೊಬ್ಬ ಬಳಕೆದಾರರಿಗೆ ನಿಯೋಜಿಸಲಾಗಿದೆ.',
        home_errExpired: 'ಈ ವೌಚರ್ ಅವಧಿ ಮೀರಿದೆ.',
        home_errSuccess: 'ವೌಚರ್ ಯಶಸ್ವಿಯಾಗಿ ಪರಿಶೀಲಿಸಲಾಗಿದೆ!',
        slogan_popupLabel: 'ಸಲ್ಲಿಸಲಾಗಿದೆ!',
        slogan_popupTitle: 'ಧನ್ಯವಾದಗಳು!',
        slogan_popupMsg: 'ನಿಮ್ಮ ಸ್ಲೋಗನ್ ಯಶಸ್ವಿಯಾಗಿ ಸಲ್ಲಿಸಲಾಗಿದೆ ಮತ್ತು ನೀವು ಗ್ರ್ಯಾಂಡ್ ಪ್ರೈಜ್ ಸ್ಪರ್ಧೆಯ ಭಾಗವಾಗಿದ್ದೀರಿ. ಫಲಿತಾಂಶಕ್ಕಾಗಿ ಕಾಯಿರಿ!',
        appTitle: 'ಜೆನ್‌ಕ್ರೆಸ್ಟ್ ಅಗ್ರೋಸತ್ವಾ',
        appDescription: 'ಸುಸ್ಥಿರ ಕೃಷಿ ಪರಿಹಾರಗಳು',

        game_betterLuck: "ಮುಂದಿನ ಬಾರಿ ಪ್ರಯತ್ನಿಸಿ",
        game_spinAndWin: "🎡 ಸ್ಪಿನ್ ಮಾಡಿ ಗೆಲ್ಲಿ",
        game_spin: "ಸ್ಪಿನ್",
        game_congratulations: "🎉 ಅಭಿನಂದನೆಗಳು!",
        game_youWon: "ನೀವು ಗೆದ್ದಿದ್ದೀರಿ",
        game_dontWorry: "ಚಿಂತಿಸಬೇಡಿ, ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ!",
        game_dashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ಗೆ ಹಿಂತಿರುಗಿ",
        game_playAgain: "ಮತ್ತೆ ಆಡಿ",
        game_luckyGame: "ಲಕ್ಕಿ ಗೇಮ್",
        game_Desc: "ಚಕ್ರವನ್ನು ತಿರುಗಿಸಿ ಮತ್ತು ತಕ್ಷಣ ಆಕರ್ಷಕ ಬಹುಮಾನಗಳನ್ನು ಗೆಲ್ಲಿ.",
        game_points: "ಪಾಯಿಂಟ್‌ಗಳು"
    },
    te: {
        welcome: "స్వాగతం రైతు", enterMobile: "కొనసాగించడానికి మొబైల్ నంబర్ నమోదు చేయండి",
        mobileLabel: "మొబైల్ నంబర్", mobilePlaceholder: "10 అంకెల మొబైల్ నంబర్ నమోదు చేయండి",
        termsText: "నేను అంగీకరిస్తున్నాను", termsLink: "నిబంధనలు మరియు షరతులు",
        submit: "సమర్పించు", sendingOtp: "OTP పంపబడుతోంది...", invalidMobile: "చెల్లని మొబైల్ నంబర్",
        otpSentTo: "కోడ్ పంపబడింది +91", loginWithOtp: "OTP తో లాగిన్ చేయండి",
        otpSentMessage: "OTP పంపబడింది +91",
        otpError: "దయచేసి OTP యొక్క అన్ని 4 అంకెలు నమోదు చేయండి",
        invalidOtp: "చెల్లని OTP. దయచేసి మళ్ళీ ప్రయత్నించండి.",
        login: "లాగిన్", verifying: "ధృవీకరిస్తోంది...",
        resendOtp: "OTP మళ్ళీ పంపు", otpResent: "OTP మళ్ళీ పంపబడింది",
        footer: "సుస్థిర వ్యవసాయ పరిష్కారాలు",
        profile_heading: "ప్రొఫైల్ పూర్తి చేయండి",
        profile_subheading: "కొనసాగించడానికి ప్రొఫైల్ పూర్తి చేయండి",
        profile_nameLabel: "పూర్తి పేరు", profile_namePlaceholder: "మీ పూర్తి పేరు నమోదు చేయండి",
        profile_pincodeLabel: "పిన్‌కోడ్", profile_pincodePlaceholder: "6 అంకెల పిన్‌కోడ్ నమోదు చేయండి",
        profile_stateLabel: "రాష్ట్రం", profile_districtLabel: "జిల్లా",
        profile_villageLabel: "గ్రామం", profile_acreageLabel: "మొత్తం ఎకరాలు",
        profile_acreagePlaceholder: "ఉదా. 12",
        profile_autoFill: "పిన్‌కోడ్ నుండి స్వయంచాలకంగా నింపబడుతుంది",
        profile_infoNote: "దయచేసి అన్ని వివరాలు జాగ్రత్తగా నింపండి. వీటిని తర్వాత మార్చలేరు.",
        profile_saveBtn: "సేవ్ చేసి కొనసాగించు",
        profile_saved: "ప్రొఫైల్ విజయవంతంగా సేవ్ చేయబడింది!",
        profile_saveError: "ఏదో తప్పు జరిగింది. దయచేసి మళ్ళీ ప్రయత్నించండి.",
        profile_invalidPincode: "చెల్లని పిన్‌కోడ్",
        profile_pincodeError: "పిన్‌కోడ్ వివరాలు పొందలేకపోయాము",
        profile_errName: "దయచేసి మీ పేరు నమోదు చేయండి",
        profile_errPincode: "చెల్లుబాటు అయ్యే 6 అంకెల పిన్‌కోడ్ నమోదు చేయండి",
        profile_errLocation: "స్థానం నింపడానికి చెల్లుబాటు అయ్యే పిన్‌కోడ్ నమోదు చేయండి",
        profile_errAcreage: "దయచేసి మొత్తం ఎకరాలు నమోదు చేయండి",
        profile_errAge: "దయచేసి వయస్సును నమోదు చేయండి",
        profile_ageLabel: "వయస్సు",

        profile_myProfile: 'నా ప్రొఫైల్',
        profile_locationDetails: 'స్థాన వివరాలు',
        profile_farmDetails: 'పొలం వివరాలు',
        profile_state: 'రాష్ట్రం',
        profile_district: 'జిల్లా',
        profile_village: 'గ్రామం',
        profile_pincode: 'పిన్‌కోడ్',
        profile_totalAcreage: 'మొత్తం ఎకరాలు',
        profile_acres: 'ఎకరాలు',
        profile_noticeText: 'ప్రొఫైల్ వివరాలు ధృవీకరించబడ్డాయి మరియు మార్చలేరు. ఏవైనా సవరణలకు సపోర్ట్‌ని సంప్రదించండి.',
        profile_backToDashboard: 'డాష్‌బోర్డ్‌కు తిరిగి వెళ్ళు',
        profile_logout: 'లాగ్ అవుట్',
        profile_logoutTitle: 'లాగ్ అవుట్ చేయాలా?',
        profile_logoutMsg: 'మీ ఖాతాను యాక్సెస్ చేయడానికి మీరు మళ్ళీ సైన్ ఇన్ చేయాలి.',
        profile_cancel: 'రద్దు చేయి',
        profile_logoutConfirm: 'అవును, లాగ్ అవుట్',

        notFound_message: 'పేజీ కనుగొనబడలేదు',
        notFound_goHome: 'హోమ్‌కి వెళ్ళు',

        slogan_pageTitle: 'స్లోగన్ పోటీ',
        slogan_contestLabel: 'గ్రాండ్ ప్రైజ్ పోటీ',
        slogan_enterTitle: 'మీ స్లోగన్ నమోదు చేయండి',
        slogan_enterSubtitle: 'పాల్గొనడానికి మరియు పెద్దది గెలవడానికి మీ సృజనాత్మక స్లోగన్ సమర్పించండి!',
        slogan_inputLabel: 'నాకు ఇది Agrosatva సీసాలో దొరికింది.',
        slogan_placeholder: 'ఇక్కడ మీ స్లోగన్ రాయండి...',
        slogan_submit: 'స్లోగన్ సమర్పించు',
        slogan_submitting: 'సమర్పిస్తోంది...',
        slogan_errEmpty: 'దయచేసి మీ స్లోగన్ నమోదు చేయండి.',
        slogan_errFailed: 'ఏదో తప్పు జరిగింది. దయచేసి మళ్ళీ ప్రయత్నించండి.',
        slogan_alreadyTitle: 'మీరు పోటీలో ఉన్నారు!',
        slogan_alreadyMsg: 'గ్రాండ్ ప్రైజ్ పోటీ కోసం మీ ఎంట్రీ మాకు ఇప్పటికే అందింది. పోటీ ముగిసిన తర్వాత ఫలితాలు ప్రకటించబడతాయి!',
        slogan_goHome: 'హోమ్‌కి వెళ్ళు',

        redeem_pageTitle: 'సంపాదన చూడండి',
        redeem_balance: 'బ్యాలెన్స్',
        redeem_totalEarned: 'మొత్తం సంపాదన',
        redeem_transferred: 'బదిలీ చేసింది',
        redeem_transferFunds: 'నిధులు బదిలీ చేయండి',
        redeem_upiId: 'UPI ID',
        redeem_bankAccount: 'బ్యాంక్ ఖాతా',
        redeem_tabEarned: 'సంపాదించింది',
        redeem_tabTransferred: 'బదిలీ',
        redeem_noTransactions: 'లావాదేవీలు లేవు',
        redeem_errNoBalance: 'బదిలీ చేయడానికి బ్యాలెన్స్ లేదు',

        scan_pageTitle: 'కోడ్ స్కాన్ చేయండి',
        scan_pointCamera: 'QR కోడ్‌కు కెమెరా చూపించండి',
        scan_cameraUnavailable: 'కెమెరా అందుబాటులో లేదు. దయచేసి క్రింద మాన్యువల్ ఎంట్రీ వాడండి.',
        scan_orEnterManually: 'లేదా మాన్యువల్‌గా నమోదు చేయండి',
        scan_placeholder: 'CB45SYR463F',
        scan_submitCode: 'కోడ్ సమర్పించు',
        scan_congrats: 'అభినందనలు!',
        scan_youEarned: 'మీరు సంపాదించారు',
        scan_cashbackRewards: 'ఒక క్యాష్‌బ్యాక్ రివార్డ్',
        scan_viewEarnings: 'ఇప్పుడే బదిలీ చేయండి',
        scan_scanAnother: 'మరొక కోడ్ స్కాన్ చేయండి',
        scan_grandPrizeBtn: 'గ్రాండ్ ప్రైజ్ పోటీలో చేరండి',
        scan_voucherVerified: 'వోచర్ ధృవీకరించబడింది',
        scan_contestSubmitted: 'పోటీ ఎంట్రీ సమర్పించబడింది ✅',
        scan_contestSubmittedMsg: 'అభినందనలు! మీరు గ్రాండ్ ప్రైజ్ పోటీకి అర్హులు. పోటీ ముగిసిన తర్వాత ఫలితాలు ప్రకటించబడతాయి.',
        scan_contestNotSubmitted: 'పోటీ ఎంట్రీ సమర్పించబడలేదు',
        scan_contestNotSubmittedMsg: 'పాల్గొనడానికి మీ స్లోగన్ సమర్పించండి!',
        scan_submitSlogan: 'స్లోగన్ సమర్పించు',
        scan_verificationFailed: 'ధృవీకరణ విఫలమైంది',
        scan_tryAgain: 'మళ్ళీ ప్రయత్నించు',
        scan_errInvalid: 'చెల్లని వోచర్ కోడ్.',
        scan_errUsed: 'ఈ వోచర్ ఇప్పటికే ఉపయోగించబడింది.',
        scan_errAssigned: 'ఈ వోచర్ ఇప్పటికే కేటాయించబడింది.',
        scan_errExpired: 'ఈ వోచర్ గడువు తీరిపోయింది.',
        scan_errSuccess: 'వోచర్ విజయవంతంగా ధృవీకరించబడింది!',

        bank_pageTitle: 'బ్యాంక్ వివరాలు',
        bank_addTitle: 'బ్యాంక్ ఖాతా జోడించు',
        bank_ifscLabel: 'IFSC కోడ్',
        bank_ifscPlaceholder: 'ఉదా. SBIN0001234',
        bank_accountLabel: 'ఖాతా నంబర్',
        bank_accountPlaceholder: 'ఖాతా నంబర్ నమోదు చేయండి',
        bank_confirmLabel: 'ఖాతా మళ్ళీ నమోదు చేయండి',
        bank_confirmPlaceholder: 'ఖాతా నంబర్ నిర్ధారించండి',
        bank_addBtn: 'ఖాతా జోడించు',
        bank_transferBtn: 'మొత్తం బదిలీ చేయండి',
        bank_addAnotherBtn: 'మరొక ఖాతా జోడించు',
        bank_holderName: 'ఖాతాదారుడు',
        bank_accountNumber: 'ఖాతా నంబర్',
        bank_ifscCode: 'IFSC కోడ్',
        bank_bankName: 'బ్యాంక్ పేరు',
        bank_default: 'డిఫాల్ట్',
        bank_setDefault: 'డిఫాల్ట్‌గా సెట్ చేయండి',
        bank_delete: 'తొలగించు',
        bank_errFillAll: 'దయచేసి అన్ని ఫీల్డులు నింపండి',
        bank_errMismatch: 'ఖాతా నంబర్లు సరిపోలలేదు',
        bank_errInvalidIfsc: 'చెల్లని IFSC కోడ్',
        bank_errVerifyFailed: 'ఖాతా ధృవీకరణ విఫలమైంది',
        bank_errVerifyError: 'ధృవీకరణ లోపం. దయచేసి మళ్ళీ ప్రయత్నించండి.',
        bank_errIfscFetch: 'బ్యాంక్ వివరాలు పొందడంలో లోపం',
        bank_successAdded: 'బ్యాంక్ ఖాతా విజయవంతంగా జోడించబడింది',
        bank_successDeleted: 'ఖాతా తొలగించబడింది',
        bank_successDefault: 'డిఫాల్ట్ ఖాతా నవీకరించబడింది',

        upi_pageTitle: 'UPI వివరాలు',
        upi_mobileLabel: 'మొబైల్ నంబర్ (UPI)',
        upi_mobilePlaceholder: 'మొబైల్ నంబర్ నమోదు చేయండి',
        upi_verifiedLabel: 'విజయవంతంగా ధృవీకరించబడింది',
        upi_name: 'పేరు',
        upi_upiId: 'UPI ID',
        upi_mobile: 'మొబైల్',
        upi_btnWait: 'దయచేసి వేచి ఉండండి...',
        upi_btnProceed: 'కొనసాగించు',
        upi_btnVerify: 'మొబైల్ నంబర్ ధృవీకరించు',
        upi_errInvalidMobile: 'చెల్లుబాటు అయ్యే 10 అంకెల మొబైల్ నంబర్ నమోదు చేయండి',
        upi_successVerified: 'మొబైల్ నంబర్ విజయవంతంగా ధృవీకరించబడింది!',
        upi_errFailed: 'మొబైల్ నంబర్ ధృవీకరణ విఫలమైంది',
        upi_errGeneric: 'ఏదో తప్పు జరిగింది. దయచేసి మళ్ళీ ప్రయత్నించండి.',

        confirm_pageTitle: 'చెల్లింపు వివరాలు',
        confirm_transferAmount: 'బదిలీ మొత్తం',
        confirm_noBalance: 'బదిలీ చేయడానికి బ్యాలెన్స్ లేదు',
        confirm_vouchersLabel: 'రిడీమ్ చేయాల్సిన వోచర్లు',
        confirm_paymentMethod: 'చెల్లింపు విధానం',
        confirm_upi: 'UPI',
        confirm_bankTransfer: 'బ్యాంక్ బదిలీ',
        confirm_bank: 'బ్యాంక్',
        confirm_account: 'ఖాతా',
        confirm_ifsc: 'IFSC',
        confirm_name: 'పేరు',
        confirm_btnNoBalance: 'బ్యాలెన్స్ లేదు',
        confirm_btnConfirm: 'నిర్ధారించు & బదిలీ చేయి',
        confirm_errGeneric: 'ఏదో తప్పు జరిగింది. దయచేసి మళ్ళీ ప్రయత్నించండి.',
        confirm_popupLabel: 'విజయవంతం',
        confirm_popupTitle:
            "మీ అభ్యర్థన విజయవంతంగా సమర్పించబడింది. చెల్లింపు 2 గంటలలో ప్రాసెస్ చేయబడుతుంది.",
        confirm_popupMsg:
            "సాయంత్రం 6 తర్వాత సమర్పించిన అభ్యర్థనలు తదుపరి పని దినంలో ప్రాసెస్ చేయబడతాయి.",
        confirm_popupTotal: 'మొత్తం రిడీమ్',
        confirm_warningTitle: '⚠ బదిలీ పెండింగ్‌లో ఉంది',
        confirm_warningMsg: 'అంతర్గత సమస్య కారణంగా మొత్తం తక్షణమే మీ ఖాతాకు బదిలీ కాలేదు. మా టీమ్ త్వరలో ప్రాసెస్ చేస్తుంది. అవసరమైతే సపోర్ట్‌ని సంప్రదించండి.',
        confirm_done: 'పూర్తయింది',

        home_welcome: 'స్వాగతం',
        home_totalEarned: 'మొత్తం సంపాదన',
        home_transferred: 'బదిలీ',
        home_balance: 'బ్యాలెన్స్',
        home_viewEarnings: 'సంపాదన చూడండి',
        home_grandPrizeBtn: 'గ్రాండ్ ప్రైజ్ పోటీలో వెళ్ళండి',
        home_promoTitle: 'ప్రోమో కోడ్',
        home_promoSubtitle: 'మీ Agrosatva ప్యాక్ నుండి QR స్కాన్ చేయండి లేదా కోడ్ నమోదు చేయండి',
        home_scanBtn: 'స్కాన్ / కోడ్ నమోదు చేయండి',
        home_enterCodeTitle: 'వోచర్ కోడ్ నమోదు చేయండి',
        home_enterCodePlaceholder: 'కోడ్ నమోదు చేయండి',
        home_submit: 'సమర్పించు',
        home_alreadyAssignedTitle: 'వోచర్ ఇప్పటికే కేటాయించబడింది!',
        home_tryAnother: 'మరొక కూపన్ ప్రయత్నించండి',
        home_congrats: 'అభినందనలు!',
        home_youEarned: 'మీరు సంపాదించారు',
        home_cashbackRewards: 'ఒక క్యాష్‌బ్యాక్ రివార్డ్',
        home_viewEarningsBtn: "ఆదాయాన్ని పొందండి",
        home_scanAnother: 'మరొక కోడ్ స్కాన్ చేయండి',
        home_inContestTitle: 'మీరు పోటీలో ఉన్నారు',
        home_congratsTitle: 'అభినందనలు',
        home_contestReceivedMsg: 'గ్రాండ్ ప్రైజ్ పోటీ కోసం మీ ఎంట్రీ మాకు ఇప్పటికే అందింది. పోటీ ముగిసిన తర్వాత ఫలితాలు ప్రకటించబడతాయి!',
        home_scanMoreBtn: 'మరింత గెలవడానికి మరొక కూపన్ స్కాన్ చేయండి',
        home_goHome: 'హోమ్‌కి వెళ్ళు',
        home_eligibleMsg: 'మీరు గ్రాండ్ ప్రైజ్ పోటీకి అర్హులు. పోటీలో పాల్గొనడానికి దయచేసి దిగువ లింక్‌పై క్లిక్ చేయండి',
        home_participate: 'పాల్గొనండి',
        home_verificationFailed: 'ధృవీకరణ విఫలమైంది',
        home_tryAgain: 'మళ్ళీ ప్రయత్నించు',
        home_errInvalid: 'చెల్లని వోచర్ కోడ్.',
        home_errUsed: 'ఈ వోచర్ ఇప్పటికే ఉపయోగించబడింది.',
        home_errMaxLimit: 'మీరు 10 వోచర్ల గరిష్ట పరిమితిని చేరుకున్నారు.',
        home_errAssignedMine: 'ఈ వోచర్ ఇప్పటికే మీ ఖాతాలో ఉంది.',
        home_errAssignedOther: 'ఈ వోచర్ ఇప్పటికే మరొక వినియోగదారుకు కేటాయించబడింది.',
        home_errExpired: 'ఈ వోచర్ గడువు తీరిపోయింది.',
        home_errSuccess: 'వోచర్ విజయవంతంగా ధృవీకరించబడింది!',
        slogan_popupLabel: 'సమర్పించబడింది!',
        slogan_popupTitle: 'ధన్యవాదాలు!',
        slogan_popupMsg: 'మీ స్లోగన్ విజయవంతంగా సమర్పించబడింది మరియు మీరు గ్రాండ్ ప్రైజ్ పోటీలో భాగమయ్యారు. ఫలితాల కోసం వేచి ఉండండి!',
        appTitle: 'జెన్‌క్రెస్ట్ అగ్రోసత్వా',
        appDescription: 'సుస్థిర వ్యవసాయ పరిష్కారాలు',

        game_betterLuck: "తర్వాతసారి ప్రయత్నించండి",
        game_spinAndWin: "🎡 స్పిన్ చేసి గెలుచుకోండి",
        game_spin: "స్పిన్",
        game_congratulations: "🎉 అభినందనలు!",
        game_youWon: "మీరు గెలిచారు",
        game_dontWorry: "చింతించకండి, మళ్లీ ప్రయత్నించండి!",
        game_dashboard: "డాష్‌బోర్డ్‌కు తిరిగి వెళ్లండి",
        game_playAgain: "మళ్లీ ఆడండి",
        game_luckyGame: "లక్కీ గేమ్",
        game_Desc: "చక్రాన్ని తిప్పి వెంటనే అద్భుతమైన బహుమతులు గెలుచుకోండి.",
        game_points: "పాయింట్లు"
    },
    ta: {
        welcome: "வரவேற்கிறோம் விவசாயி", enterMobile: "தொடர மொபைல் எண் உள்ளிடவும்",
        mobileLabel: "மொபைல் எண்", mobilePlaceholder: "10 இலக்க மொபைல் எண் உள்ளிடவும்",
        termsText: "நான் ஏற்கிறேன்", termsLink: "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
        submit: "சமர்ப்பிக்கவும்", sendingOtp: "OTP அனுப்பப்படுகிறது...", invalidMobile: "தவறான மொபைல் எண்",
        otpSentTo: "குறியீடு அனுப்பப்பட்டது +91", loginWithOtp: "OTP மூலம் உள்நுழைக",
        otpSentMessage: "OTP அனுப்பப்பட்டது +91",
        otpError: "தயவுசெய்து OTP இன் அனைத்து 4 இலக்கங்களையும் உள்ளிடவும்",
        invalidOtp: "தவறான OTP. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
        login: "உள்நுழை", verifying: "சரிபார்க்கப்படுகிறது...",
        resendOtp: "OTP மீண்டும் அனுப்பு", otpResent: "OTP மீண்டும் அனுப்பப்பட்டது",
        footer: "நிலையான விவசாய தீர்வுகள்",
        profile_heading: "சுயவிவரத்தை நிறைவு செய்யுங்கள்",
        profile_subheading: "தொடர சுயவிவரத்தை நிறைவு செய்யுங்கள்",
        profile_nameLabel: "முழு பெயர்", profile_namePlaceholder: "உங்கள் முழு பெயரை உள்ளிடவும்",
        profile_pincodeLabel: "பின்கோடு", profile_pincodePlaceholder: "6 இலக்க பின்கோடை உள்ளிடவும்",
        profile_stateLabel: "மாநிலம்", profile_districtLabel: "மாவட்டம்",
        profile_villageLabel: "கிராமம்", profile_acreageLabel: "மொத்த ஏக்கர்",
        profile_acreagePlaceholder: "எ.கா. 12",
        profile_autoFill: "பின்கோட்டிலிருந்து தானாக நிரப்பப்படும்",
        profile_infoNote: "தயவுசெய்து அனைத்து விவரங்களையும் கவனமாக நிரப்பவும். இவற்றை பிறகு மாற்ற முடியாது.",
        profile_saveBtn: "சேமித்து தொடரவும்",
        profile_saved: "சுயவிவரம் வெற்றிகரமாக சேமிக்கப்பட்டது!",
        profile_saveError: "ஏதோ தவறு நடந்தது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
        profile_invalidPincode: "தவறான பின்கோடு",
        profile_pincodeError: "பின்கோடு விவரங்களை பெற முடியவில்லை",
        profile_errName: "தயவுசெய்து உங்கள் பெயரை உள்ளிடவும்",
        profile_errPincode: "சரியான 6 இலக்க பின்கோடை உள்ளிடவும்",
        profile_errLocation: "இடத்தை நிரப்ப சரியான பின்கோடை உள்ளிடவும்",
        profile_errAcreage: "தயவுசெய்து மொத்த ஏக்கரை உள்ளிடவும்",
        profile_errAge: "தயவுசெய்து வயதை உள்ளிடவும்",
        profile_ageLabel: "வயது",

        profile_myProfile: 'என் சுயவிவரம்',
        profile_locationDetails: 'இட விவரங்கள்',
        profile_farmDetails: 'பண்ணை விவரங்கள்',
        profile_state: 'மாநிலம்',
        profile_district: 'மாவட்டம்',
        profile_village: 'கிராமம்',
        profile_pincode: 'பின்கோடு',
        profile_totalAcreage: 'மொத்த ஏக்கர்',
        profile_acres: 'ஏக்கர்',
        profile_noticeText: 'சுயவிவர விவரங்கள் சரிபார்க்கப்பட்டுள்ளன மற்றும் மாற்ற முடியாது. எந்த திருத்தங்களுக்கும் ஆதரவை தொடர்பு கொள்ளவும்.',
        profile_backToDashboard: 'டாஷ்போர்டுக்கு திரும்பு',
        profile_logout: 'வெளியேறு',
        profile_logoutTitle: 'வெளியேறுவீர்களா?',
        profile_logoutMsg: 'உங்கள் கணக்கை அணுக மீண்டும் உள்நுழைய வேண்டும்.',
        profile_cancel: 'ரத்து செய்',
        profile_logoutConfirm: 'ஆம், வெளியேறு',

        notFound_message: 'பக்கம் கிடைக்கவில்லை',
        notFound_goHome: 'முகப்புக்கு செல்',

        slogan_pageTitle: 'கோஷவரி போட்டி',
        slogan_contestLabel: 'கிராண்ட் பரிசு போட்டி',
        slogan_enterTitle: 'உங்கள் கோஷவரியை உள்ளிடவும்',
        slogan_enterSubtitle: 'பங்கேற்று பெரிய பரிசு வெல்ல உங்கள் படைப்பாற்றல் கோஷவரியை சமர்ப்பிக்கவும்!',
        slogan_inputLabel: 'எனக்கு இது Agrosatva பாட்டிலில் கிடைத்தது.',
        slogan_placeholder: 'இங்கே உங்கள் கோஷவரியை எழுதவும்...',
        slogan_submit: 'கோஷவரி சமர்ப்பிக்கவும்',
        slogan_submitting: 'சமர்ப்பிக்கப்படுகிறது...',
        slogan_errEmpty: 'தயவுசெய்து உங்கள் கோஷவரியை உள்ளிடவும்.',
        slogan_errFailed: 'ஏதோ தவறு நடந்தது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.',
        slogan_alreadyTitle: 'நீங்கள் போட்டியில் இருக்கிறீர்கள்!',
        slogan_alreadyMsg: 'கிராண்ட் பரிசு போட்டிக்கான உங்கள் பதிவு எங்களுக்கு ஏற்கனவே கிடைத்துள்ளது. போட்டி முடிந்ததும் முடிவுகள் அறிவிக்கப்படும்!',
        slogan_goHome: 'முகப்புக்கு செல்',

        redeem_pageTitle: 'வருவாய் பார்க்கவும்',
        redeem_balance: 'இருப்பு',
        redeem_totalEarned: 'மொத்த வருவாய்',
        redeem_transferred: 'மாற்றப்பட்டது',
        redeem_transferFunds: 'நிதி மாற்றவும்',
        redeem_upiId: 'UPI ID',
        redeem_bankAccount: 'வங்கி கணக்கு',
        redeem_tabEarned: 'சம்பாதித்தது',
        redeem_tabTransferred: 'மாற்றம்',
        redeem_noTransactions: 'பரிவர்த்தனைகள் இல்லை',
        redeem_errNoBalance: 'மாற்ற இருப்பு எதுவும் இல்லை',

        scan_pageTitle: 'குறியீட்டை ஸ்கேன் செய்யுங்கள்',
        scan_pointCamera: 'QR குறியீட்டில் கேமராவை நோக்குங்கள்',
        scan_cameraUnavailable: 'கேமரா கிடைக்கவில்லை. தயவுசெய்து கீழே கைமுறை உள்ளீடு பயன்படுத்தவும்.',
        scan_orEnterManually: 'அல்லது கைமுறையாக உள்ளிடவும்',
        scan_placeholder: 'CB45SYR463F',
        scan_submitCode: 'குறியீட்டை சமர்ப்பிக்கவும்',
        scan_congrats: 'வாழ்த்துக்கள்!',
        scan_youEarned: 'நீங்கள் சம்பாதித்தீர்கள்',
        scan_cashbackRewards: 'ஒரு கேஷ்பேக் வெகுமதி',
        scan_viewEarnings: 'இப்போதே பரிமாற்றம் செய்யுங்கள்',
        scan_scanAnother: 'மற்றொரு குறியீட்டை ஸ்கேன் செய்யுங்கள்',
        scan_grandPrizeBtn: 'கிராண்ட் பரிசு போட்டியில் சேரவும்',
        scan_voucherVerified: 'வவுச்சர் சரிபார்க்கப்பட்டது',
        scan_contestSubmitted: 'போட்டி பதிவு சமர்ப்பிக்கப்பட்டது ✅',
        scan_contestSubmittedMsg: 'வாழ்த்துக்கள்! நீங்கள் கிராண்ட் பரிசு போட்டிக்கு தகுதியானவர். போட்டி முடிந்ததும் முடிவுகள் அறிவிக்கப்படும்.',
        scan_contestNotSubmitted: 'போட்டி பதிவு சமர்ப்பிக்கப்படவில்லை',
        scan_contestNotSubmittedMsg: 'பங்கேற்க உங்கள் கோஷவரியை சமர்ப்பிக்கவும்!',
        scan_submitSlogan: 'கோஷவரி சமர்ப்பிக்கவும்',
        scan_verificationFailed: 'சரிபார்ப்பு தோல்வி',
        scan_tryAgain: 'மீண்டும் முயற்சிக்கவும்',
        scan_errInvalid: 'தவறான வவுச்சர் குறியீடு.',
        scan_errUsed: 'இந்த வவுச்சர் ஏற்கனவே பயன்படுத்தப்பட்டுவிட்டது.',
        scan_errAssigned: 'இந்த வவுச்சர் ஏற்கனவே ஒதுக்கப்பட்டுவிட்டது.',
        scan_errExpired: 'இந்த வவுச்சரின் காலாவதி தேதி கடந்துவிட்டது.',
        scan_errSuccess: 'வவுச்சர் வெற்றிகரமாக சரிபார்க்கப்பட்டது!',

        bank_pageTitle: 'வங்கி விவரங்கள்',
        bank_addTitle: 'வங்கி கணக்கை சேர்க்கவும்',
        bank_ifscLabel: 'IFSC குறியீடு',
        bank_ifscPlaceholder: 'எ.கா. SBIN0001234',
        bank_accountLabel: 'கணக்கு எண்',
        bank_accountPlaceholder: 'கணக்கு எண்ணை உள்ளிடவும்',
        bank_confirmLabel: 'கணக்கை மீண்டும் உள்ளிடவும்',
        bank_confirmPlaceholder: 'கணக்கு எண்ணை உறுதிப்படுத்தவும்',
        bank_addBtn: 'கணக்கை சேர்க்கவும்',
        bank_transferBtn: 'தொகையை மாற்றவும்',
        bank_addAnotherBtn: 'மற்றொரு கணக்கை சேர்க்கவும்',
        bank_holderName: 'கணக்குதாரர்',
        bank_accountNumber: 'கணக்கு எண்',
        bank_ifscCode: 'IFSC குறியீடு',
        bank_bankName: 'வங்கி பெயர்',
        bank_default: 'இயல்புநிலை',
        bank_setDefault: 'இயல்புநிலையாக அமைக்கவும்',
        bank_delete: 'நீக்கு',
        bank_errFillAll: 'தயவுசெய்து அனைத்து புலங்களையும் நிரப்பவும்',
        bank_errMismatch: 'கணக்கு எண்கள் பொருந்தவில்லை',
        bank_errInvalidIfsc: 'தவறான IFSC குறியீடு',
        bank_errVerifyFailed: 'கணக்கு சரிபார்ப்பு தோல்வி',
        bank_errVerifyError: 'சரிபார்ப்பு பிழை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.',
        bank_errIfscFetch: 'வங்கி விவரங்களை பெறுவதில் பிழை',
        bank_successAdded: 'வங்கி கணக்கு வெற்றிகரமாக சேர்க்கப்பட்டது',
        bank_successDeleted: 'கணக்கு நீக்கப்பட்டது',
        bank_successDefault: 'இயல்புநிலை கணக்கு புதுப்பிக்கப்பட்டது',

        upi_pageTitle: 'UPI விவரங்கள்',
        upi_mobileLabel: 'மொபைல் எண் (UPI)',
        upi_mobilePlaceholder: 'மொபைல் எண்ணை உள்ளிடவும்',
        upi_verifiedLabel: 'வெற்றிகரமாக சரிபார்க்கப்பட்டது',
        upi_name: 'பெயர்',
        upi_upiId: 'UPI ID',
        upi_mobile: 'மொபைல்',
        upi_btnWait: 'தயவுசெய்து காத்திருங்கள்...',
        upi_btnProceed: 'தொடரவும்',
        upi_btnVerify: 'மொபைல் எண்ணை சரிபார்க்கவும்',
        upi_errInvalidMobile: 'சரியான 10 இலக்க மொபைல் எண்ணை உள்ளிடவும்',
        upi_successVerified: 'மொபைல் எண் வெற்றிகரமாக சரிபார்க்கப்பட்டது!',
        upi_errFailed: 'மொபைல் எண் சரிபார்ப்பு தோல்வி',
        upi_errGeneric: 'ஏதோ தவறு நடந்தது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.',

        confirm_pageTitle: 'கட்டண விவரங்கள்',
        confirm_transferAmount: 'மாற்றும் தொகை',
        confirm_noBalance: 'மாற்ற இருப்பு எதுவும் இல்லை',
        confirm_vouchersLabel: 'பரிமாற்றம் செய்ய வவுச்சர்கள்',
        confirm_paymentMethod: 'கட்டண முறை',
        confirm_upi: 'UPI',
        confirm_bankTransfer: 'வங்கி பரிமாற்றம்',
        confirm_bank: 'வங்கி',
        confirm_account: 'கணக்கு',
        confirm_ifsc: 'IFSC',
        confirm_name: 'பெயர்',
        confirm_btnNoBalance: 'இருப்பு இல்லை',
        confirm_btnConfirm: 'உறுதிப்படுத்து & மாற்று',
        confirm_errGeneric: 'ஏதோ தவறு நடந்தது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.',
        confirm_popupLabel: 'வெற்றி',
        confirm_popupTitle:
            "உங்கள் கோரிக்கை வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது. கட்டணம் 2 மணிநேரத்தில் செயல்படுத்தப்படும்.",
        confirm_popupMsg:
            "மாலை 6 மணிக்குப் பிறகு சமர்ப்பிக்கப்பட்ட கோரிக்கைகள் அடுத்த வேலை நாளில் செயல்படுத்தப்படும்.",
        confirm_popupTotal: 'மொத்தம் பரிமாற்றம்',
        confirm_warningTitle: '⚠ பரிமாற்றம் நிலுவையில்',
        confirm_warningMsg: 'உள்கட்டமைப்பு சிக்கல் காரணமாக தொகை உடனடியாக உங்கள் கணக்கிற்கு மாற்றப்படவில்லை. எங்கள் குழு விரைவில் செயலாக்கும். தேவைப்பட்டால் ஆதரவை தொடர்பு கொள்ளவும்.',
        confirm_done: 'முடிந்தது',

        home_welcome: 'வரவேற்கிறோம்',
        home_totalEarned: 'மொத்த வருவாய்',
        home_transferred: 'மாற்றம்',
        home_balance: 'இருப்பு',
        home_viewEarnings: 'வருவாய் பார்க்கவும்',
        home_grandPrizeBtn: 'கிராண்ட் பரிசு போட்டிக்கு செல்லுங்கள்',
        home_promoTitle: 'ப்ரோமோ குறியீடு',
        home_promoSubtitle: 'உங்கள் Agrosatva பேக்கிலிருந்து QR ஸ்கேன் செய்யுங்கள் அல்லது குறியீட்டை உள்ளிடவும்',
        home_scanBtn: 'ஸ்கேன் / குறியீடு உள்ளிடவும்',
        home_enterCodeTitle: 'வவுச்சர் குறியீட்டை உள்ளிடவும்',
        home_enterCodePlaceholder: 'குறியீட்டை உள்ளிடவும்',
        home_submit: 'சமர்ப்பிக்கவும்',
        home_alreadyAssignedTitle: 'வவுச்சர் ஏற்கனவேஒதுக்கப்பட்டுவிட்டது!',
        home_tryAnother: 'மற்றொரு கூப்பனை முயற்சிக்கவும்',
        home_congrats: 'வாழ்த்துக்கள்!',
        home_youEarned: 'நீங்கள் சம்பாதித்தீர்கள்',
        home_cashbackRewards: 'ஒரு கேஷ்பேக் வெகுமதி',
        home_viewEarningsBtn: "வருமானத்தை பெறுங்கள்",
        home_scanAnother: 'மற்றொரு குறியீட்டை ஸ்கேன் செய்யுங்கள்',
        home_inContestTitle: 'நீங்கள் போட்டியில் இருக்கிறீர்கள்',
        home_congratsTitle: 'வாழ்த்துக்கள்',
        home_contestReceivedMsg: 'கிராண்ட் பரிசு போட்டிக்கான உங்கள் பதிவு எங்களுக்கு ஏற்கனவே கிடைத்துவிட்டது. போட்டி முடிந்ததும் முடிவுகள் அறிவிக்கப்படும்!',
        home_scanMoreBtn: 'மேலும் வெல்ல மற்றொரு கூப்பனை ஸ்கேன் செய்யுங்கள்',
        home_goHome: 'முகப்புக்கு செல்',
        home_eligibleMsg: 'நீங்கள் கிராண்ட் பரிசு போட்டிக்கு தகுதியானவர். பங்கேற்க கீழே உள்ள இணைப்பை கிளிக் செய்யவும்',
        home_participate: 'பங்கேற்கவும்',
        home_verificationFailed: 'சரிபார்ப்பு தோல்வி',
        home_tryAgain: 'மீண்டும் முயற்சிக்கவும்',
        home_errInvalid: 'தவறான வவுச்சர் குறியீடு.',
        home_errUsed: 'இந்த வவுச்சர் ஏற்கனவே பயன்படுத்தப்பட்டுவிட்டது.',
        home_errMaxLimit: 'நீங்கள் 10 வவுச்சர்களின் அதிகபட்ச வரம்பை எட்டிவிட்டீர்கள்.',
        home_errAssignedMine: 'இந்த வவுச்சர் ஏற்கனவே உங்கள் கணக்கில் உள்ளது.',
        home_errAssignedOther: 'இந்த வவுச்சர் ஏற்கனவே மற்றொரு பயனருக்கு ஒதுக்கப்பட்டுவிட்டது.',
        home_errExpired: 'இந்த வவுச்சரின் காலாவதி தேதி கடந்துவிட்டது.',
        home_errSuccess: 'வவுச்சர் வெற்றிகரமாக சரிபார்க்கப்பட்டது!',
        slogan_popupLabel: 'சமர்ப்பிக்கப்பட்டது!',
        slogan_popupTitle: 'நன்றி!',
        slogan_popupMsg: 'உங்கள் கோஷவரி வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது மற்றும் நீங்கள் கிராண்ட் பரிசு போட்டியின் பகுதியாகிவிட்டீர்கள். முடிவுகளுக்காக காத்திருங்கள்!',
        appTitle: 'ஜென்கிரெஸ்ட் அக்ரோசத்வா',
        appDescription: 'நிலையான விவசாய தீர்வுகள்',

        game_betterLuck: "அடுத்த முறை முயற்சிக்கவும்",
        game_spinAndWin: "🎡 சுற்றி வெல்லுங்கள்",
        game_spin: "சுற்று",
        game_congratulations: "🎉 வாழ்த்துக்கள்!",
        game_youWon: "நீங்கள் வென்றுள்ளீர்கள்",
        game_dontWorry: "கவலைப்பட வேண்டாம், மீண்டும் முயற்சிக்கவும்!",
        game_dashboard: "டாஷ்போர்டுக்கு திரும்ப செல்லவும்",
        game_playAgain: "மீண்டும் விளையாடுங்கள்",
        game_luckyGame: "அதிர்ஷ்ட விளையாட்டு",
        game_Desc: "சக்கரத்தை சுற்றி உடனே அற்புதமான பரிசுகளை வெல்லுங்கள்.",
        game_points: "புள்ளிகள்"
    },
};

// localStorage se current language ka translation return karta hai
export const getT = () => {
    const lang = localStorage.getItem('appLanguage') || 'en';
    return translations[lang] || translations['en'];
};